export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDateTime: { input: any; output: any; }
  AWSEmail: { input: any; output: any; }
  AWSJSON: { input: any; output: any; }
  AWSTimestamp: { input: any; output: any; }
  AWSURL: { input: any; output: any; }
}

export enum AccessControlType {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export interface IAccountCoupon extends INode {
  __typename?: 'AccountCoupon';
  awsAccountId?: Maybe<Scalars['ID']['output']>;
  configRegion: AwsRegion;
  configType: ConfigType;
  couponRedemptionConnection?: Maybe<IAccountCouponCouponRedemptionsConnection>;
  createdAt: Scalars['String']['output'];
  duration?: Maybe<CouponDuration>;
  durationInMonth?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  maxRedemptions?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<RedemptionStatus>;
  updatedAt?: Maybe<Scalars['String']['output']>;
}


export interface IAccountCouponCouponRedemptionConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ICouponRedemptionComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}

export interface IAccountCouponComparisonInput {
  and?: InputMaybe<Array<InputMaybe<IAccountCouponComparisonInput>>>;
  awsAccountId?: InputMaybe<IIdComparisonInput>;
  configRegion?: InputMaybe<IAwsRegionComparisonInput>;
  configType?: InputMaybe<IConfigTypeComparisonInput>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  duration?: InputMaybe<ICouponDurationComparisonInput>;
  durationInMonth?: InputMaybe<IIntComparisonInput>;
  maxRedemptions?: InputMaybe<IIntComparisonInput>;
  not?: InputMaybe<IAccountCouponComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<IAccountCouponComparisonInput>>>;
  status?: InputMaybe<IRedemptionStatusComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface IAccountCouponCouponRedemptionsConnection {
  __typename?: 'AccountCouponCouponRedemptionsConnection';
  items?: Maybe<Array<Maybe<ICouponRedemption>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IAccountCouponDeleteInput {
  id: Scalars['ID']['input'];
}

export interface IAccountCouponInput {
  awsAccountId: Scalars['ID']['input'];
  configRegion: AwsRegion;
  configType: ConfigType;
  duration?: InputMaybe<CouponDuration>;
  durationInMonth?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<RedemptionStatus>;
}

export interface IAccountCouponUpdateInput {
  awsAccountId?: InputMaybe<Scalars['ID']['input']>;
  configRegion?: InputMaybe<AwsRegion>;
  configType?: InputMaybe<ConfigType>;
  duration?: InputMaybe<CouponDuration>;
  durationInMonth?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<RedemptionStatus>;
}

export interface IAccountCouponsConnection {
  __typename?: 'AccountCouponsConnection';
  items?: Maybe<Array<Maybe<IAccountCoupon>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IApi extends INode {
  __typename?: 'Api';
  additionalAuthModes?: Maybe<Array<Maybe<AuthMethodType>>>;
  apiGatewayUrl?: Maybe<Scalars['AWSURL']['output']>;
  apiGatewayWsUrl?: Maybe<Scalars['AWSURL']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  authProviderClientId?: Maybe<Scalars['ID']['output']>;
  authProviderPoolId?: Maybe<Scalars['ID']['output']>;
  authProviderType?: Maybe<AuthProviderType>;
  authProviderUrl?: Maybe<Scalars['AWSURL']['output']>;
  awsAccountId?: Maybe<Scalars['ID']['output']>;
  bucket?: Maybe<Scalars['String']['output']>;
  bundleSubscriptionConnection?: Maybe<IApiBundleSubscriptionsConnection>;
  checkoutSessionConnection?: Maybe<IApiCheckoutSessionsConnection>;
  createdAt: Scalars['String']['output'];
  creationType?: Maybe<ApiCreationType>;
  customerAppConnection?: Maybe<IApiCustomerAppsConnection>;
  customerSecretConnection?: Maybe<IApiCustomerSecretsConnection>;
  defaultAuthMode?: Maybe<AuthMethodType>;
  externalId?: Maybe<Scalars['ID']['output']>;
  graphqlUrl?: Maybe<Scalars['AWSURL']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  oidc?: Maybe<Scalars['AWSJSON']['output']>;
  orgId?: Maybe<Scalars['ID']['output']>;
  publishRunConnection?: Maybe<IApiPublishRunsConnection>;
  queryExplorerString?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  schema?: Maybe<Scalars['AWSJSON']['output']>;
  schemaPromptConnection?: Maybe<IApiSchemaPromptsConnection>;
  stackName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<PublishingState>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  usePrefix?: Maybe<Scalars['Boolean']['output']>;
}


export interface IApiBundleSubscriptionConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IBundleSubscriptionComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IApiCheckoutSessionConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ICheckoutSessionComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IApiCustomerAppConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ICustomerAppComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IApiCustomerSecretConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ICustomerSecretComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IApiPublishRunConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IPublishRunComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IApiSchemaPromptConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ISchemaPromptComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}

export interface IApiBundleSubscriptionsConnection {
  __typename?: 'ApiBundleSubscriptionsConnection';
  items?: Maybe<Array<Maybe<IBundleSubscription>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IApiCheckoutSessionsConnection {
  __typename?: 'ApiCheckoutSessionsConnection';
  items?: Maybe<Array<Maybe<ICheckoutSession>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IApiComparisonInput {
  additionalAuthModes?: InputMaybe<IAuthMethodTypeComparisonInput>;
  and?: InputMaybe<Array<InputMaybe<IApiComparisonInput>>>;
  apiGatewayUrl?: InputMaybe<IStringComparisonInput>;
  apiGatewayWsUrl?: InputMaybe<IStringComparisonInput>;
  apiKey?: InputMaybe<IStringComparisonInput>;
  authProviderClientId?: InputMaybe<IIdComparisonInput>;
  authProviderPoolId?: InputMaybe<IIdComparisonInput>;
  authProviderType?: InputMaybe<IAuthProviderTypeComparisonInput>;
  authProviderUrl?: InputMaybe<IStringComparisonInput>;
  awsAccountId?: InputMaybe<IIdComparisonInput>;
  bucket?: InputMaybe<IStringComparisonInput>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  creationType?: InputMaybe<IApiCreationTypeComparisonInput>;
  defaultAuthMode?: InputMaybe<IAuthMethodTypeComparisonInput>;
  externalId?: InputMaybe<IIdComparisonInput>;
  graphqlUrl?: InputMaybe<IStringComparisonInput>;
  name?: InputMaybe<IStringComparisonInput>;
  not?: InputMaybe<IApiComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<IApiComparisonInput>>>;
  orgId?: InputMaybe<IIdComparisonInput>;
  queryExplorerString?: InputMaybe<IStringComparisonInput>;
  region?: InputMaybe<IStringComparisonInput>;
  stackName?: InputMaybe<IStringComparisonInput>;
  state?: InputMaybe<IPublishingStateComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
  usePrefix?: InputMaybe<IBooleanComparisonInput>;
}

export enum ApiCreationType {
  IMPORT = 'IMPORT',
  PUBLISH = 'PUBLISH'
}

export interface IApiCreationTypeComparisonInput {
  eq?: InputMaybe<ApiCreationType>;
  ne?: InputMaybe<ApiCreationType>;
}

export interface IApiCustomerAppsConnection {
  __typename?: 'ApiCustomerAppsConnection';
  items?: Maybe<Array<Maybe<ICustomerApp>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IApiCustomerSecretsConnection {
  __typename?: 'ApiCustomerSecretsConnection';
  items?: Maybe<Array<Maybe<ICustomerSecret>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IApiDeleteInput {
  id: Scalars['ID']['input'];
}

export interface IApiInput {
  additionalAuthModes?: InputMaybe<Array<InputMaybe<AuthMethodType>>>;
  apiGatewayUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  apiGatewayWsUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  authProviderClientId?: InputMaybe<Scalars['ID']['input']>;
  authProviderPoolId?: InputMaybe<Scalars['ID']['input']>;
  authProviderType?: InputMaybe<AuthProviderType>;
  authProviderUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  awsAccountId?: InputMaybe<Scalars['ID']['input']>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  creationType?: InputMaybe<ApiCreationType>;
  defaultAuthMode?: InputMaybe<AuthMethodType>;
  externalId?: InputMaybe<Scalars['ID']['input']>;
  graphqlUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  oidc?: InputMaybe<Scalars['AWSJSON']['input']>;
  orgId: Scalars['ID']['input'];
  queryExplorerString?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
  schema?: InputMaybe<Scalars['AWSJSON']['input']>;
  stackName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<PublishingState>;
  usePrefix?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface IApiPublishRunsConnection {
  __typename?: 'ApiPublishRunsConnection';
  items?: Maybe<Array<Maybe<IPublishRun>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IApiSchemaPromptsConnection {
  __typename?: 'ApiSchemaPromptsConnection';
  items?: Maybe<Array<Maybe<ISchemaPrompt>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IApiUpdateInput {
  additionalAuthModes?: InputMaybe<Array<InputMaybe<AuthMethodType>>>;
  apiGatewayUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  apiGatewayWsUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  authProviderClientId?: InputMaybe<Scalars['ID']['input']>;
  authProviderPoolId?: InputMaybe<Scalars['ID']['input']>;
  authProviderType?: InputMaybe<AuthProviderType>;
  authProviderUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  awsAccountId?: InputMaybe<Scalars['ID']['input']>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  creationType?: InputMaybe<ApiCreationType>;
  defaultAuthMode?: InputMaybe<AuthMethodType>;
  externalId?: InputMaybe<Scalars['ID']['input']>;
  graphqlUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  oidc?: InputMaybe<Scalars['AWSJSON']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  queryExplorerString?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['AWSJSON']['input']>;
  stackName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<PublishingState>;
  usePrefix?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface IApisConnection {
  __typename?: 'ApisConnection';
  items?: Maybe<Array<Maybe<IApi>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export enum ArchiveFormatType {
  NONE = 'NONE',
  ZIP = 'ZIP'
}

export enum AuthMethodType {
  AWS_API_KEY = 'aws_api_key',
  AWS_COGNITO_USER_POOLS = 'aws_cognito_user_pools',
  AWS_IAM = 'aws_iam',
  AWS_OIDC = 'aws_oidc'
}

export interface IAuthMethodTypeComparisonInput {
  eq?: InputMaybe<AuthMethodType>;
  ne?: InputMaybe<AuthMethodType>;
}

export enum AuthProviderType {
  AWS = 'AWS'
}

export interface IAuthProviderTypeComparisonInput {
  eq?: InputMaybe<AuthProviderType>;
  ne?: InputMaybe<AuthProviderType>;
}

export enum AwsRegion {
  AP_NORTHEAST_1 = 'AP_NORTHEAST_1',
  AP_NORTHEAST_2 = 'AP_NORTHEAST_2',
  AP_SOUTHEAST_1 = 'AP_SOUTHEAST_1',
  AP_SOUTHEAST_2 = 'AP_SOUTHEAST_2',
  AP_SOUTH_1 = 'AP_SOUTH_1',
  CA_CENTRAL_1 = 'CA_CENTRAL_1',
  EU_CENTRAL_1 = 'EU_CENTRAL_1',
  EU_NORTH_1 = 'EU_NORTH_1',
  EU_WEST_1 = 'EU_WEST_1',
  EU_WEST_2 = 'EU_WEST_2',
  EU_WEST_3 = 'EU_WEST_3',
  ME_SOUTH_1 = 'ME_SOUTH_1',
  SA_EAST_1 = 'SA_EAST_1',
  US_EAST_2 = 'US_EAST_2',
  US_WEST_1 = 'US_WEST_1',
  US_WEST_2 = 'US_WEST_2'
}

export interface IAwsRegionComparisonInput {
  eq?: InputMaybe<AwsRegion>;
  ne?: InputMaybe<AwsRegion>;
}

export interface IBenefit extends INode {
  __typename?: 'Benefit';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lang?: Maybe<LanguageCode>;
  productName: Scalars['String']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
}

export interface IBenefitComparisonInput {
  and?: InputMaybe<Array<InputMaybe<IBenefitComparisonInput>>>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  description?: InputMaybe<IStringComparisonInput>;
  lang?: InputMaybe<ILanguageCodeComparisonInput>;
  not?: InputMaybe<IBenefitComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<IBenefitComparisonInput>>>;
  productName?: InputMaybe<IStringComparisonInput>;
  rank?: InputMaybe<IIntComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface IBenefitDeleteInput {
  id: Scalars['ID']['input'];
}

export interface IBenefitInput {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  lang: LanguageCode;
  productName: Scalars['String']['input'];
  rank: Scalars['Int']['input'];
}

export interface IBenefitUpdateInput {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lang?: InputMaybe<LanguageCode>;
  productName?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
}

export interface IBenefitsConnection {
  __typename?: 'BenefitsConnection';
  items?: Maybe<Array<Maybe<IBenefit>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IBillingAccount extends INode {
  __typename?: 'BillingAccount';
  billingAddress?: Maybe<Scalars['AWSJSON']['output']>;
  billingEmail?: Maybe<Scalars['AWSEmail']['output']>;
  createdAt: Scalars['String']['output'];
  currency?: Maybe<CurrencyType>;
  id: Scalars['ID']['output'];
  invoiceConnection?: Maybe<IBillingAccountInvoicesConnection>;
  name?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['ID']['output']>;
  paymentProviderId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
}


export interface IBillingAccountInvoiceConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IInvoiceComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}

export interface IBillingAccountComparisonInput {
  and?: InputMaybe<Array<InputMaybe<IBillingAccountComparisonInput>>>;
  billingEmail?: InputMaybe<IStringComparisonInput>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  currency?: InputMaybe<ICurrencyTypeComparisonInput>;
  name?: InputMaybe<IStringComparisonInput>;
  not?: InputMaybe<IBillingAccountComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<IBillingAccountComparisonInput>>>;
  orgId?: InputMaybe<IIdComparisonInput>;
  paymentProviderId?: InputMaybe<IIdComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
  vatId?: InputMaybe<IStringComparisonInput>;
}

export interface IBillingAccountDeleteInput {
  id: Scalars['ID']['input'];
  paymentProviderId: Scalars['ID']['input'];
}

export interface IBillingAccountInput {
  billingAddress?: InputMaybe<Scalars['AWSJSON']['input']>;
  billingEmail: Scalars['AWSEmail']['input'];
  currency?: InputMaybe<CurrencyType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
  paymentProviderId: Scalars['ID']['input'];
  vatId?: InputMaybe<Scalars['String']['input']>;
}

export interface IBillingAccountInvoicesConnection {
  __typename?: 'BillingAccountInvoicesConnection';
  items?: Maybe<Array<Maybe<IInvoice>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IBillingAccountUpdateInput {
  billingAddress?: InputMaybe<Scalars['AWSJSON']['input']>;
  billingEmail?: InputMaybe<Scalars['AWSEmail']['input']>;
  currency?: InputMaybe<CurrencyType>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderId: Scalars['ID']['input'];
  vatId?: InputMaybe<Scalars['String']['input']>;
}

export interface IBillingAccountsConnection {
  __typename?: 'BillingAccountsConnection';
  items?: Maybe<Array<Maybe<IBillingAccount>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export enum BillingInterval {
  DAY = 'DAY',
  MONTH = 'MONTH',
  ONETIME = 'ONETIME',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export interface IBillingIntervalComparisonInput {
  eq?: InputMaybe<BillingInterval>;
  ne?: InputMaybe<BillingInterval>;
}

export enum BillingScheme {
  PER_UNIT = 'PER_UNIT',
  TIERED = 'TIERED'
}

export interface IBillingSchemeComparisonInput {
  eq?: InputMaybe<BillingScheme>;
  ne?: InputMaybe<BillingScheme>;
}

export interface IBooleanComparisonInput {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ComparisonAttributeType>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface IBundleSubscription extends INode {
  __typename?: 'BundleSubscription';
  apiId?: Maybe<Scalars['ID']['output']>;
  billingCycleAnchor?: Maybe<Scalars['AWSTimestamp']['output']>;
  billingCycleEnd?: Maybe<Scalars['AWSTimestamp']['output']>;
  billingCycleStart?: Maybe<Scalars['AWSTimestamp']['output']>;
  billingInterval?: Maybe<BillingInterval>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lineItems?: Maybe<Scalars['AWSJSON']['output']>;
  orgId?: Maybe<Scalars['ID']['output']>;
  paymentProviderCheckoutSessionId?: Maybe<Scalars['ID']['output']>;
  paymentProviderCustomerId?: Maybe<Scalars['ID']['output']>;
  paymentProviderId?: Maybe<Scalars['ID']['output']>;
  paymentProviderSubscriptionItemIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subscriptionItemConnection?: Maybe<IBundleSubscriptionSubscriptionItemsConnection>;
  updatedAt?: Maybe<Scalars['String']['output']>;
}


export interface IBundleSubscriptionSubscriptionItemConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ISubscriptionItemComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}

export interface IBundleSubscriptionComparisonInput {
  and?: InputMaybe<Array<InputMaybe<IBundleSubscriptionComparisonInput>>>;
  apiId?: InputMaybe<IIdComparisonInput>;
  billingCycleAnchor?: InputMaybe<IIntComparisonInput>;
  billingCycleEnd?: InputMaybe<IIntComparisonInput>;
  billingCycleStart?: InputMaybe<IIntComparisonInput>;
  billingInterval?: InputMaybe<IBillingIntervalComparisonInput>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  not?: InputMaybe<IBundleSubscriptionComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<IBundleSubscriptionComparisonInput>>>;
  orgId?: InputMaybe<IIdComparisonInput>;
  paymentProviderCheckoutSessionId?: InputMaybe<IIdComparisonInput>;
  paymentProviderCustomerId?: InputMaybe<IIdComparisonInput>;
  paymentProviderId?: InputMaybe<IIdComparisonInput>;
  paymentProviderSubscriptionItemIds?: InputMaybe<IIdComparisonInput>;
  products?: InputMaybe<IStringComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface IBundleSubscriptionDeleteInput {
  id: Scalars['ID']['input'];
  paymentProviderId: Scalars['ID']['input'];
}

export interface IBundleSubscriptionInput {
  apiId: Scalars['ID']['input'];
  billingCycleAnchor?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  billingCycleEnd?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  billingCycleStart?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  billingInterval?: InputMaybe<BillingInterval>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lineItems: Scalars['AWSJSON']['input'];
  orgId: Scalars['ID']['input'];
  paymentProviderCheckoutSessionId?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderCustomerId: Scalars['ID']['input'];
  paymentProviderId: Scalars['ID']['input'];
  paymentProviderSubscriptionItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  products: Array<Scalars['String']['input']>;
}

export interface IBundleSubscriptionSubscriptionItemsConnection {
  __typename?: 'BundleSubscriptionSubscriptionItemsConnection';
  items?: Maybe<Array<Maybe<ISubscriptionItem>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IBundleSubscriptionUpdateInput {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  billingCycleAnchor?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  billingCycleEnd?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  billingCycleStart?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  billingInterval?: InputMaybe<BillingInterval>;
  id: Scalars['ID']['input'];
  lineItems?: InputMaybe<Scalars['AWSJSON']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderCheckoutSessionId?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderCustomerId?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderId: Scalars['ID']['input'];
  paymentProviderSubscriptionItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface IBundleSubscriptionsConnection {
  __typename?: 'BundleSubscriptionsConnection';
  items?: Maybe<Array<Maybe<IBundleSubscription>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export enum BundleType {
  LAUNCH = 'LAUNCH',
  MVP = 'MVP',
  PROFESSIONAL = 'PROFESSIONAL',
  SCALE = 'SCALE',
  SCALEUP = 'SCALEUP',
  SEED = 'SEED',
  STARTER = 'STARTER',
  STARTUP = 'STARTUP'
}

export interface IBundleTypeComparisonInput {
  eq?: InputMaybe<BundleType>;
  ne?: InputMaybe<BundleType>;
}

export interface ICheckoutSession extends INode {
  __typename?: 'CheckoutSession';
  apiId?: Maybe<Scalars['ID']['output']>;
  bundleType?: Maybe<Scalars['String']['output']>;
  cancelUrl?: Maybe<Scalars['AWSURL']['output']>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  id: Scalars['ID']['output'];
  lineItems?: Maybe<Scalars['AWSJSON']['output']>;
  metadata?: Maybe<Scalars['AWSJSON']['output']>;
  orgId?: Maybe<Scalars['ID']['output']>;
  paymentProviderId?: Maybe<Scalars['ID']['output']>;
  products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sessionId?: Maybe<Scalars['ID']['output']>;
  sessionUrl?: Maybe<Scalars['AWSURL']['output']>;
  successUrl?: Maybe<Scalars['AWSURL']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
}

export interface ICheckoutSessionComparisonInput {
  and?: InputMaybe<Array<InputMaybe<ICheckoutSessionComparisonInput>>>;
  apiId?: InputMaybe<IIdComparisonInput>;
  bundleType?: InputMaybe<IStringComparisonInput>;
  cancelUrl?: InputMaybe<IStringComparisonInput>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  description?: InputMaybe<IStringComparisonInput>;
  expiresAt?: InputMaybe<IIntComparisonInput>;
  not?: InputMaybe<ICheckoutSessionComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<ICheckoutSessionComparisonInput>>>;
  orgId?: InputMaybe<IIdComparisonInput>;
  paymentProviderId?: InputMaybe<IIdComparisonInput>;
  products?: InputMaybe<IStringComparisonInput>;
  sessionId?: InputMaybe<IIdComparisonInput>;
  sessionUrl?: InputMaybe<IStringComparisonInput>;
  successUrl?: InputMaybe<IStringComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface ICheckoutSessionDeleteInput {
  id: Scalars['ID']['input'];
  paymentProviderId: Scalars['ID']['input'];
}

export interface ICheckoutSessionInput {
  apiId: Scalars['ID']['input'];
  bundleType: Scalars['String']['input'];
  cancelUrl: Scalars['AWSURL']['input'];
  description: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lineItems: Scalars['AWSJSON']['input'];
  metadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  orgId: Scalars['ID']['input'];
  paymentProviderId: Scalars['ID']['input'];
  products: Array<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  sessionUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  successUrl: Scalars['AWSURL']['input'];
}

export interface ICheckoutSessionUpdateInput {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  bundleType?: InputMaybe<Scalars['String']['input']>;
  cancelUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  id: Scalars['ID']['input'];
  lineItems?: InputMaybe<Scalars['AWSJSON']['input']>;
  metadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderId: Scalars['ID']['input'];
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  sessionUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  successUrl?: InputMaybe<Scalars['AWSURL']['input']>;
}

export interface ICheckoutSessionsConnection {
  __typename?: 'CheckoutSessionsConnection';
  items?: Maybe<Array<Maybe<ICheckoutSession>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export enum ComparisonAttributeType {
  NULL = '_null',
  BINARY = 'binary',
  BINARY_SET = 'binarySet',
  BOOL = 'bool',
  LIST = 'list',
  MAP = 'map',
  NUMBER = 'number',
  NUMBER_SET = 'numberSet',
  STRING = 'string',
  STRING_SET = 'stringSet'
}

export interface IConfig extends INode {
  __typename?: 'Config';
  accountCouponConnection?: Maybe<IConfigAccountCouponsConnection>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  region?: Maybe<AwsRegion>;
  type?: Maybe<ConfigType>;
  updatedAt?: Maybe<Scalars['String']['output']>;
}


export interface IConfigAccountCouponConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IAccountCouponComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}

export interface IConfigAccountCouponsConnection {
  __typename?: 'ConfigAccountCouponsConnection';
  items?: Maybe<Array<Maybe<IAccountCoupon>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IConfigComparisonInput {
  and?: InputMaybe<Array<InputMaybe<IConfigComparisonInput>>>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  not?: InputMaybe<IConfigComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<IConfigComparisonInput>>>;
  region?: InputMaybe<IAwsRegionComparisonInput>;
  type?: InputMaybe<IConfigTypeComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface IConfigDeleteInput {
  id: Scalars['ID']['input'];
}

export interface IConfigInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  region?: InputMaybe<AwsRegion>;
  type?: InputMaybe<ConfigType>;
}

export enum ConfigType {
  AWS_ACCOUNT = 'AWS_ACCOUNT'
}

export interface IConfigTypeComparisonInput {
  eq?: InputMaybe<ConfigType>;
  ne?: InputMaybe<ConfigType>;
}

export interface IConfigUpdateInput {
  id: Scalars['ID']['input'];
  region?: InputMaybe<AwsRegion>;
  type?: InputMaybe<ConfigType>;
}

export interface IConfigsConnection {
  __typename?: 'ConfigsConnection';
  items?: Maybe<Array<Maybe<IConfig>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export enum CouponDuration {
  FOREVER = 'FOREVER',
  ONCE = 'ONCE',
  REPEATING = 'REPEATING'
}

export interface ICouponDurationComparisonInput {
  eq?: InputMaybe<CouponDuration>;
  ne?: InputMaybe<CouponDuration>;
}

export interface ICouponRedemption extends INode {
  __typename?: 'CouponRedemption';
  accountCouponConfigType: ConfigType;
  couponCode?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  redeemedById?: Maybe<Scalars['ID']['output']>;
  redeemedByType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
}

export interface ICouponRedemptionComparisonInput {
  accountCouponConfigType?: InputMaybe<IConfigTypeComparisonInput>;
  and?: InputMaybe<Array<InputMaybe<ICouponRedemptionComparisonInput>>>;
  couponCode?: InputMaybe<IIdComparisonInput>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  not?: InputMaybe<ICouponRedemptionComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<ICouponRedemptionComparisonInput>>>;
  redeemedById?: InputMaybe<IIdComparisonInput>;
  redeemedByType?: InputMaybe<IStringComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface ICouponRedemptionDeleteInput {
  id: Scalars['ID']['input'];
}

export interface ICouponRedemptionInput {
  accountCouponConfigType: ConfigType;
  couponCode: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  redeemedById: Scalars['ID']['input'];
  redeemedByType: Scalars['String']['input'];
}

export interface ICouponRedemptionUpdateInput {
  accountCouponConfigType?: InputMaybe<ConfigType>;
  couponCode?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  redeemedById?: InputMaybe<Scalars['ID']['input']>;
  redeemedByType?: InputMaybe<Scalars['String']['input']>;
}

export interface ICouponRedemptionsConnection {
  __typename?: 'CouponRedemptionsConnection';
  items?: Maybe<Array<Maybe<ICouponRedemption>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export enum CurrencyType {
  EUR = 'EUR',
  USD = 'USD'
}

export interface ICurrencyTypeComparisonInput {
  eq?: InputMaybe<CurrencyType>;
  ne?: InputMaybe<CurrencyType>;
}

export interface ICustomerApp extends INode {
  __typename?: 'CustomerApp';
  apiId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastEditorId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  schema?: Maybe<Scalars['AWSJSON']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
}

export interface ICustomerAppComparisonInput {
  and?: InputMaybe<Array<InputMaybe<ICustomerAppComparisonInput>>>;
  apiId?: InputMaybe<IIdComparisonInput>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  lastEditorId?: InputMaybe<IIdComparisonInput>;
  name?: InputMaybe<IStringComparisonInput>;
  not?: InputMaybe<ICustomerAppComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<ICustomerAppComparisonInput>>>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface ICustomerAppDeleteInput {
  id: Scalars['ID']['input'];
}

export interface ICustomerAppInput {
  apiId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  lastEditorId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  schema?: InputMaybe<Scalars['AWSJSON']['input']>;
}

export interface ICustomerAppUpdateInput {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  lastEditorId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['AWSJSON']['input']>;
}

export interface ICustomerAppsConnection {
  __typename?: 'CustomerAppsConnection';
  items?: Maybe<Array<Maybe<ICustomerApp>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface ICustomerSecret extends INode {
  __typename?: 'CustomerSecret';
  apiId?: Maybe<Scalars['ID']['output']>;
  arn?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  secretValue?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  versionId?: Maybe<Scalars['String']['output']>;
}

export interface ICustomerSecretComparisonInput {
  and?: InputMaybe<Array<InputMaybe<ICustomerSecretComparisonInput>>>;
  apiId?: InputMaybe<IIdComparisonInput>;
  arn?: InputMaybe<IStringComparisonInput>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  description?: InputMaybe<IStringComparisonInput>;
  name?: InputMaybe<IStringComparisonInput>;
  not?: InputMaybe<ICustomerSecretComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<ICustomerSecretComparisonInput>>>;
  secretValue?: InputMaybe<IStringComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
  versionId?: InputMaybe<IStringComparisonInput>;
}

export interface ICustomerSecretDeleteInput {
  id: Scalars['ID']['input'];
}

export interface ICustomerSecretInput {
  apiId: Scalars['ID']['input'];
  arn?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  secretValue?: InputMaybe<Scalars['String']['input']>;
  versionId?: InputMaybe<Scalars['String']['input']>;
}

export interface ICustomerSecretUpdateInput {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  secretValue?: InputMaybe<Scalars['String']['input']>;
  versionId?: InputMaybe<Scalars['String']['input']>;
}

export interface ICustomerSecretsConnection {
  __typename?: 'CustomerSecretsConnection';
  items?: Maybe<Array<Maybe<ICustomerSecret>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IFloatComparisonInput {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ComparisonAttributeType>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  ge?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  le?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
}

export interface IFlow extends INode {
  __typename?: 'Flow';
  apiId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  flowRunConnection?: Maybe<IFlowFlowRunsConnection>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  schema?: Maybe<Scalars['AWSJSON']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
}


export interface IFlowFlowRunConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IFlowRunComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}

export interface IFlowComparisonInput {
  and?: InputMaybe<Array<InputMaybe<IFlowComparisonInput>>>;
  apiId?: InputMaybe<IIdComparisonInput>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  name?: InputMaybe<IStringComparisonInput>;
  not?: InputMaybe<IFlowComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<IFlowComparisonInput>>>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface IFlowDeleteInput {
  id: Scalars['ID']['input'];
}

export interface IFlowFlowRunsConnection {
  __typename?: 'FlowFlowRunsConnection';
  items?: Maybe<Array<Maybe<IFlowRun>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IFlowInput {
  apiId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  schema?: InputMaybe<Scalars['AWSJSON']['input']>;
}

export interface IFlowRun extends INode {
  __typename?: 'FlowRun';
  createdAt: Scalars['String']['output'];
  flowId?: Maybe<Scalars['ID']['output']>;
  flowRunLogConnection?: Maybe<IFlowRunFlowRunLogsConnection>;
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
}


export interface IFlowRunFlowRunLogConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IFlowRunLogComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}

export interface IFlowRunComparisonInput {
  and?: InputMaybe<Array<InputMaybe<IFlowRunComparisonInput>>>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  flowId?: InputMaybe<IIdComparisonInput>;
  not?: InputMaybe<IFlowRunComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<IFlowRunComparisonInput>>>;
  status?: InputMaybe<IStringComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface IFlowRunDeleteInput {
  id: Scalars['ID']['input'];
}

export interface IFlowRunFlowRunLogsConnection {
  __typename?: 'FlowRunFlowRunLogsConnection';
  items?: Maybe<Array<Maybe<IFlowRunLog>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IFlowRunInput {
  flowId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  status: Scalars['String']['input'];
}

export interface IFlowRunLog extends INode {
  __typename?: 'FlowRunLog';
  content?: Maybe<Scalars['AWSJSON']['output']>;
  createdAt: Scalars['String']['output'];
  flowRunId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
}

export interface IFlowRunLogComparisonInput {
  and?: InputMaybe<Array<InputMaybe<IFlowRunLogComparisonInput>>>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  flowRunId?: InputMaybe<IIdComparisonInput>;
  not?: InputMaybe<IFlowRunLogComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<IFlowRunLogComparisonInput>>>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface IFlowRunLogDeleteInput {
  id: Scalars['ID']['input'];
}

export interface IFlowRunLogInput {
  content?: InputMaybe<Scalars['AWSJSON']['input']>;
  flowRunId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
}

export interface IFlowRunLogUpdateInput {
  content?: InputMaybe<Scalars['AWSJSON']['input']>;
  flowRunId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
}

export interface IFlowRunLogsConnection {
  __typename?: 'FlowRunLogsConnection';
  items?: Maybe<Array<Maybe<IFlowRunLog>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IFlowRunUpdateInput {
  flowId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
}

export interface IFlowRunsConnection {
  __typename?: 'FlowRunsConnection';
  items?: Maybe<Array<Maybe<IFlowRun>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IFlowUpdateInput {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['AWSJSON']['input']>;
}

export interface IFlowsConnection {
  __typename?: 'FlowsConnection';
  items?: Maybe<Array<Maybe<IFlow>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IIdComparisonInput {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ComparisonAttributeType>;
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<ISizeComparisonInput>;
}

export interface IInlineS3ObjectInput {
  accessControl?: InputMaybe<AccessControlType>;
  archiveFormat?: InputMaybe<ArchiveFormatType>;
  body?: InputMaybe<Scalars['String']['input']>;
  bucket: Scalars['String']['input'];
  key: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
}

export interface IIntComparisonInput {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ComparisonAttributeType>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
}

export interface IInvoice extends INode {
  __typename?: 'Invoice';
  amountPaid?: Maybe<Scalars['Int']['output']>;
  billingAccountPaymentProviderId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  currency?: Maybe<CurrencyType>;
  date?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  invoicePdf?: Maybe<Scalars['AWSURL']['output']>;
  status?: Maybe<InvoiceStatusEnum>;
  updatedAt?: Maybe<Scalars['String']['output']>;
}

export interface IInvoiceComparisonInput {
  amountPaid?: InputMaybe<IIntComparisonInput>;
  and?: InputMaybe<Array<InputMaybe<IInvoiceComparisonInput>>>;
  billingAccountPaymentProviderId?: InputMaybe<IIdComparisonInput>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  currency?: InputMaybe<ICurrencyTypeComparisonInput>;
  date?: InputMaybe<IStringComparisonInput>;
  invoicePdf?: InputMaybe<IStringComparisonInput>;
  not?: InputMaybe<IInvoiceComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<IInvoiceComparisonInput>>>;
  status?: InputMaybe<IInvoiceStatusEnumComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface IInvoiceDeleteInput {
  id: Scalars['ID']['input'];
}

export interface IInvoiceInput {
  amountPaid: Scalars['Int']['input'];
  billingAccountPaymentProviderId: Scalars['ID']['input'];
  currency?: InputMaybe<CurrencyType>;
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invoicePdf?: InputMaybe<Scalars['AWSURL']['input']>;
  status?: InputMaybe<InvoiceStatusEnum>;
}

export enum InvoiceStatusEnum {
  DRAFT = 'draft',
  OPEN = 'open',
  PAID = 'paid',
  UNCOLLECTIBLE = 'uncollectible',
  VOID = 'void'
}

export interface IInvoiceStatusEnumComparisonInput {
  eq?: InputMaybe<InvoiceStatusEnum>;
  ne?: InputMaybe<InvoiceStatusEnum>;
}

export interface IInvoiceUpdateInput {
  amountPaid?: InputMaybe<Scalars['Int']['input']>;
  billingAccountPaymentProviderId?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<CurrencyType>;
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  invoicePdf?: InputMaybe<Scalars['AWSURL']['input']>;
  status?: InputMaybe<InvoiceStatusEnum>;
}

export interface IInvoicesConnection {
  __typename?: 'InvoicesConnection';
  items?: Maybe<Array<Maybe<IInvoice>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export enum LanguageCode {
  DE = 'DE',
  EN = 'EN'
}

export interface ILanguageCodeComparisonInput {
  eq?: InputMaybe<LanguageCode>;
  ne?: InputMaybe<LanguageCode>;
}

export interface IMutation {
  __typename?: 'Mutation';
  batchCreateAccountCoupon?: Maybe<Array<Maybe<IAccountCoupon>>>;
  batchCreateApi?: Maybe<Array<Maybe<IApi>>>;
  batchCreateBenefit?: Maybe<Array<Maybe<IBenefit>>>;
  batchCreateBillingAccount?: Maybe<Array<Maybe<IBillingAccount>>>;
  batchCreateBundleSubscription?: Maybe<Array<Maybe<IBundleSubscription>>>;
  batchCreateCheckoutSession?: Maybe<Array<Maybe<ICheckoutSession>>>;
  batchCreateConfig?: Maybe<Array<Maybe<IConfig>>>;
  batchCreateCouponRedemption?: Maybe<Array<Maybe<ICouponRedemption>>>;
  batchCreateCustomerApp?: Maybe<Array<Maybe<ICustomerApp>>>;
  batchCreateCustomerSecret?: Maybe<Array<Maybe<ICustomerSecret>>>;
  batchCreateFlow?: Maybe<Array<Maybe<IFlow>>>;
  batchCreateFlowRun?: Maybe<Array<Maybe<IFlowRun>>>;
  batchCreateFlowRunLog?: Maybe<Array<Maybe<IFlowRunLog>>>;
  batchCreateInvoice?: Maybe<Array<Maybe<IInvoice>>>;
  batchCreateOrg?: Maybe<Array<Maybe<IOrg>>>;
  batchCreatePermission?: Maybe<Array<Maybe<IPermission>>>;
  batchCreatePrice?: Maybe<Array<Maybe<IPrice>>>;
  batchCreateProduct?: Maybe<Array<Maybe<IProduct>>>;
  batchCreateProductBundle?: Maybe<Array<Maybe<IProductBundle>>>;
  batchCreatePublishRun?: Maybe<Array<Maybe<IPublishRun>>>;
  batchCreateRole?: Maybe<Array<Maybe<IRole>>>;
  batchCreateSchemaPrompt?: Maybe<Array<Maybe<ISchemaPrompt>>>;
  batchCreateSchemaTemplate?: Maybe<Array<Maybe<ISchemaTemplate>>>;
  batchCreateSchemaTemplateLocalization?: Maybe<Array<Maybe<ISchemaTemplateLocalization>>>;
  batchCreateSubscriptionItem?: Maybe<Array<Maybe<ISubscriptionItem>>>;
  batchCreateUsageRecord?: Maybe<Array<Maybe<IUsageRecord>>>;
  batchCreateUser?: Maybe<Array<Maybe<IUser>>>;
  batchDeleteAccountCoupon?: Maybe<Array<Maybe<IAccountCoupon>>>;
  batchDeleteApi?: Maybe<Array<Maybe<IApi>>>;
  batchDeleteBenefit?: Maybe<Array<Maybe<IBenefit>>>;
  batchDeleteBillingAccount?: Maybe<Array<Maybe<IBillingAccount>>>;
  batchDeleteBundleSubscription?: Maybe<Array<Maybe<IBundleSubscription>>>;
  batchDeleteCheckoutSession?: Maybe<Array<Maybe<ICheckoutSession>>>;
  batchDeleteConfig?: Maybe<Array<Maybe<IConfig>>>;
  batchDeleteCouponRedemption?: Maybe<Array<Maybe<ICouponRedemption>>>;
  batchDeleteCustomerApp?: Maybe<Array<Maybe<ICustomerApp>>>;
  batchDeleteCustomerSecret?: Maybe<Array<Maybe<ICustomerSecret>>>;
  batchDeleteFlow?: Maybe<Array<Maybe<IFlow>>>;
  batchDeleteFlowRun?: Maybe<Array<Maybe<IFlowRun>>>;
  batchDeleteFlowRunLog?: Maybe<Array<Maybe<IFlowRunLog>>>;
  batchDeleteInvoice?: Maybe<Array<Maybe<IInvoice>>>;
  batchDeleteOrg?: Maybe<Array<Maybe<IOrg>>>;
  batchDeletePermission?: Maybe<Array<Maybe<IPermission>>>;
  batchDeletePrice?: Maybe<Array<Maybe<IPrice>>>;
  batchDeleteProduct?: Maybe<Array<Maybe<IProduct>>>;
  batchDeleteProductBundle?: Maybe<Array<Maybe<IProductBundle>>>;
  batchDeletePublishRun?: Maybe<Array<Maybe<IPublishRun>>>;
  batchDeleteRole?: Maybe<Array<Maybe<IRole>>>;
  batchDeleteSchemaPrompt?: Maybe<Array<Maybe<ISchemaPrompt>>>;
  batchDeleteSchemaTemplate?: Maybe<Array<Maybe<ISchemaTemplate>>>;
  batchDeleteSchemaTemplateLocalization?: Maybe<Array<Maybe<ISchemaTemplateLocalization>>>;
  batchDeleteSubscriptionItem?: Maybe<Array<Maybe<ISubscriptionItem>>>;
  batchDeleteUsageRecord?: Maybe<Array<Maybe<IUsageRecord>>>;
  batchDeleteUser?: Maybe<Array<Maybe<IUser>>>;
  createAccountCoupon?: Maybe<IAccountCoupon>;
  createApi?: Maybe<IApi>;
  createBenefit?: Maybe<IBenefit>;
  createBillingAccount?: Maybe<IBillingAccount>;
  createBundleSubscription?: Maybe<IBundleSubscription>;
  createCheckoutSession?: Maybe<ICheckoutSession>;
  createConfig?: Maybe<IConfig>;
  createCouponRedemption?: Maybe<ICouponRedemption>;
  createCustomerApp?: Maybe<ICustomerApp>;
  createCustomerSecret?: Maybe<ICustomerSecret>;
  createFlow?: Maybe<IFlow>;
  createFlowRun?: Maybe<IFlowRun>;
  createFlowRunLog?: Maybe<IFlowRunLog>;
  createInvoice?: Maybe<IInvoice>;
  createOrg?: Maybe<IOrg>;
  createPermission?: Maybe<IPermission>;
  createPrice?: Maybe<IPrice>;
  createProduct?: Maybe<IProduct>;
  createProductBundle?: Maybe<IProductBundle>;
  createPublishRun?: Maybe<IPublishRun>;
  createRole?: Maybe<IRole>;
  createSchemaPrompt?: Maybe<ISchemaPrompt>;
  createSchemaTemplate?: Maybe<ISchemaTemplate>;
  createSchemaTemplateLocalization?: Maybe<ISchemaTemplateLocalization>;
  createSubscriptionItem?: Maybe<ISubscriptionItem>;
  createUsageRecord?: Maybe<IUsageRecord>;
  createUser?: Maybe<IUser>;
  deleteAccountCoupon?: Maybe<IAccountCoupon>;
  deleteApi?: Maybe<IApi>;
  deleteBenefit?: Maybe<IBenefit>;
  deleteBillingAccount?: Maybe<IBillingAccount>;
  deleteBundleSubscription?: Maybe<IBundleSubscription>;
  deleteCheckoutSession?: Maybe<ICheckoutSession>;
  deleteConfig?: Maybe<IConfig>;
  deleteCouponRedemption?: Maybe<ICouponRedemption>;
  deleteCustomerApp?: Maybe<ICustomerApp>;
  deleteCustomerSecret?: Maybe<ICustomerSecret>;
  deleteFlow?: Maybe<IFlow>;
  deleteFlowRun?: Maybe<IFlowRun>;
  deleteFlowRunLog?: Maybe<IFlowRunLog>;
  deleteInvoice?: Maybe<IInvoice>;
  deleteOrg?: Maybe<IOrg>;
  deletePermission?: Maybe<IPermission>;
  deletePrice?: Maybe<IPrice>;
  deleteProduct?: Maybe<IProduct>;
  deleteProductBundle?: Maybe<IProductBundle>;
  deletePublishRun?: Maybe<IPublishRun>;
  deleteRole?: Maybe<IRole>;
  deleteSchemaPrompt?: Maybe<ISchemaPrompt>;
  deleteSchemaTemplate?: Maybe<ISchemaTemplate>;
  deleteSchemaTemplateLocalization?: Maybe<ISchemaTemplateLocalization>;
  deleteSubscriptionItem?: Maybe<ISubscriptionItem>;
  deleteUsageRecord?: Maybe<IUsageRecord>;
  deleteUser?: Maybe<IUser>;
  updateAccountCoupon?: Maybe<IAccountCoupon>;
  updateApi?: Maybe<IApi>;
  updateBenefit?: Maybe<IBenefit>;
  updateBillingAccount?: Maybe<IBillingAccount>;
  updateBundleSubscription?: Maybe<IBundleSubscription>;
  updateCheckoutSession?: Maybe<ICheckoutSession>;
  updateConfig?: Maybe<IConfig>;
  updateCouponRedemption?: Maybe<ICouponRedemption>;
  updateCustomerApp?: Maybe<ICustomerApp>;
  updateCustomerSecret?: Maybe<ICustomerSecret>;
  updateFlow?: Maybe<IFlow>;
  updateFlowRun?: Maybe<IFlowRun>;
  updateFlowRunLog?: Maybe<IFlowRunLog>;
  updateInvoice?: Maybe<IInvoice>;
  updateOrg?: Maybe<IOrg>;
  updatePermission?: Maybe<IPermission>;
  updatePrice?: Maybe<IPrice>;
  updateProduct?: Maybe<IProduct>;
  updateProductBundle?: Maybe<IProductBundle>;
  updatePublishRun?: Maybe<IPublishRun>;
  updateRole?: Maybe<IRole>;
  updateSchemaPrompt?: Maybe<ISchemaPrompt>;
  updateSchemaTemplate?: Maybe<ISchemaTemplate>;
  updateSchemaTemplateLocalization?: Maybe<ISchemaTemplateLocalization>;
  updateSubscriptionItem?: Maybe<ISubscriptionItem>;
  updateUsageRecord?: Maybe<IUsageRecord>;
  updateUser?: Maybe<IUser>;
  uploadInlineS3Object?: Maybe<IS3Object>;
  uploadS3ObjectIntent?: Maybe<IS3ObjectUploadIntent>;
}


export interface IMutationBatchCreateAccountCouponArgs {
  input?: InputMaybe<Array<IAccountCouponInput>>;
}


export interface IMutationBatchCreateApiArgs {
  input?: InputMaybe<Array<IApiInput>>;
}


export interface IMutationBatchCreateBenefitArgs {
  input?: InputMaybe<Array<IBenefitInput>>;
}


export interface IMutationBatchCreateBillingAccountArgs {
  input?: InputMaybe<Array<IBillingAccountInput>>;
}


export interface IMutationBatchCreateBundleSubscriptionArgs {
  input?: InputMaybe<Array<IBundleSubscriptionInput>>;
}


export interface IMutationBatchCreateCheckoutSessionArgs {
  input?: InputMaybe<Array<ICheckoutSessionInput>>;
}


export interface IMutationBatchCreateConfigArgs {
  input?: InputMaybe<Array<IConfigInput>>;
}


export interface IMutationBatchCreateCouponRedemptionArgs {
  input?: InputMaybe<Array<ICouponRedemptionInput>>;
}


export interface IMutationBatchCreateCustomerAppArgs {
  input?: InputMaybe<Array<ICustomerAppInput>>;
}


export interface IMutationBatchCreateCustomerSecretArgs {
  input?: InputMaybe<Array<ICustomerSecretInput>>;
}


export interface IMutationBatchCreateFlowArgs {
  input?: InputMaybe<Array<IFlowInput>>;
}


export interface IMutationBatchCreateFlowRunArgs {
  input?: InputMaybe<Array<IFlowRunInput>>;
}


export interface IMutationBatchCreateFlowRunLogArgs {
  input?: InputMaybe<Array<IFlowRunLogInput>>;
}


export interface IMutationBatchCreateInvoiceArgs {
  input?: InputMaybe<Array<IInvoiceInput>>;
}


export interface IMutationBatchCreateOrgArgs {
  input?: InputMaybe<Array<IOrgInput>>;
}


export interface IMutationBatchCreatePermissionArgs {
  input?: InputMaybe<Array<IPermissionInput>>;
}


export interface IMutationBatchCreatePriceArgs {
  input?: InputMaybe<Array<IPriceInput>>;
}


export interface IMutationBatchCreateProductArgs {
  input?: InputMaybe<Array<IProductInput>>;
}


export interface IMutationBatchCreateProductBundleArgs {
  input?: InputMaybe<Array<IProductBundleInput>>;
}


export interface IMutationBatchCreatePublishRunArgs {
  input?: InputMaybe<Array<IPublishRunInput>>;
}


export interface IMutationBatchCreateRoleArgs {
  input?: InputMaybe<Array<IRoleInput>>;
}


export interface IMutationBatchCreateSchemaPromptArgs {
  input?: InputMaybe<Array<ISchemaPromptInput>>;
}


export interface IMutationBatchCreateSchemaTemplateArgs {
  input?: InputMaybe<Array<ISchemaTemplateInput>>;
}


export interface IMutationBatchCreateSchemaTemplateLocalizationArgs {
  input?: InputMaybe<Array<ISchemaTemplateLocalizationInput>>;
}


export interface IMutationBatchCreateSubscriptionItemArgs {
  input?: InputMaybe<Array<ISubscriptionItemInput>>;
}


export interface IMutationBatchCreateUsageRecordArgs {
  input?: InputMaybe<Array<IUsageRecordInput>>;
}


export interface IMutationBatchCreateUserArgs {
  input?: InputMaybe<Array<IUserInput>>;
}


export interface IMutationBatchDeleteAccountCouponArgs {
  input?: InputMaybe<Array<IAccountCouponDeleteInput>>;
}


export interface IMutationBatchDeleteApiArgs {
  input?: InputMaybe<Array<IApiDeleteInput>>;
}


export interface IMutationBatchDeleteBenefitArgs {
  input?: InputMaybe<Array<IBenefitDeleteInput>>;
}


export interface IMutationBatchDeleteBillingAccountArgs {
  input?: InputMaybe<Array<IBillingAccountDeleteInput>>;
}


export interface IMutationBatchDeleteBundleSubscriptionArgs {
  input?: InputMaybe<Array<IBundleSubscriptionDeleteInput>>;
}


export interface IMutationBatchDeleteCheckoutSessionArgs {
  input?: InputMaybe<Array<ICheckoutSessionDeleteInput>>;
}


export interface IMutationBatchDeleteConfigArgs {
  input?: InputMaybe<Array<IConfigDeleteInput>>;
}


export interface IMutationBatchDeleteCouponRedemptionArgs {
  input?: InputMaybe<Array<ICouponRedemptionDeleteInput>>;
}


export interface IMutationBatchDeleteCustomerAppArgs {
  input?: InputMaybe<Array<ICustomerAppDeleteInput>>;
}


export interface IMutationBatchDeleteCustomerSecretArgs {
  input?: InputMaybe<Array<ICustomerSecretDeleteInput>>;
}


export interface IMutationBatchDeleteFlowArgs {
  input?: InputMaybe<Array<IFlowDeleteInput>>;
}


export interface IMutationBatchDeleteFlowRunArgs {
  input?: InputMaybe<Array<IFlowRunDeleteInput>>;
}


export interface IMutationBatchDeleteFlowRunLogArgs {
  input?: InputMaybe<Array<IFlowRunLogDeleteInput>>;
}


export interface IMutationBatchDeleteInvoiceArgs {
  input?: InputMaybe<Array<IInvoiceDeleteInput>>;
}


export interface IMutationBatchDeleteOrgArgs {
  input?: InputMaybe<Array<IOrgDeleteInput>>;
}


export interface IMutationBatchDeletePermissionArgs {
  input?: InputMaybe<Array<IPermissionDeleteInput>>;
}


export interface IMutationBatchDeletePriceArgs {
  input?: InputMaybe<Array<IPriceDeleteInput>>;
}


export interface IMutationBatchDeleteProductArgs {
  input?: InputMaybe<Array<IProductDeleteInput>>;
}


export interface IMutationBatchDeleteProductBundleArgs {
  input?: InputMaybe<Array<IProductBundleDeleteInput>>;
}


export interface IMutationBatchDeletePublishRunArgs {
  input?: InputMaybe<Array<IPublishRunDeleteInput>>;
}


export interface IMutationBatchDeleteRoleArgs {
  input?: InputMaybe<Array<IRoleDeleteInput>>;
}


export interface IMutationBatchDeleteSchemaPromptArgs {
  input?: InputMaybe<Array<ISchemaPromptDeleteInput>>;
}


export interface IMutationBatchDeleteSchemaTemplateArgs {
  input?: InputMaybe<Array<ISchemaTemplateDeleteInput>>;
}


export interface IMutationBatchDeleteSchemaTemplateLocalizationArgs {
  input?: InputMaybe<Array<ISchemaTemplateLocalizationDeleteInput>>;
}


export interface IMutationBatchDeleteSubscriptionItemArgs {
  input?: InputMaybe<Array<ISubscriptionItemDeleteInput>>;
}


export interface IMutationBatchDeleteUsageRecordArgs {
  input?: InputMaybe<Array<IUsageRecordDeleteInput>>;
}


export interface IMutationBatchDeleteUserArgs {
  input?: InputMaybe<Array<IUserDeleteInput>>;
}


export interface IMutationCreateAccountCouponArgs {
  condition?: InputMaybe<IAccountCouponComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: IAccountCouponInput;
}


export interface IMutationCreateApiArgs {
  condition?: InputMaybe<IApiComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: IApiInput;
}


export interface IMutationCreateBenefitArgs {
  condition?: InputMaybe<IBenefitComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: IBenefitInput;
}


export interface IMutationCreateBillingAccountArgs {
  condition?: InputMaybe<IBillingAccountComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: IBillingAccountInput;
}


export interface IMutationCreateBundleSubscriptionArgs {
  condition?: InputMaybe<IBundleSubscriptionComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: IBundleSubscriptionInput;
}


export interface IMutationCreateCheckoutSessionArgs {
  condition?: InputMaybe<ICheckoutSessionComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: ICheckoutSessionInput;
}


export interface IMutationCreateConfigArgs {
  condition?: InputMaybe<IConfigComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: IConfigInput;
}


export interface IMutationCreateCouponRedemptionArgs {
  condition?: InputMaybe<ICouponRedemptionComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: ICouponRedemptionInput;
}


export interface IMutationCreateCustomerAppArgs {
  condition?: InputMaybe<ICustomerAppComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: ICustomerAppInput;
}


export interface IMutationCreateCustomerSecretArgs {
  condition?: InputMaybe<ICustomerSecretComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: ICustomerSecretInput;
}


export interface IMutationCreateFlowArgs {
  condition?: InputMaybe<IFlowComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: IFlowInput;
}


export interface IMutationCreateFlowRunArgs {
  condition?: InputMaybe<IFlowRunComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: IFlowRunInput;
}


export interface IMutationCreateFlowRunLogArgs {
  condition?: InputMaybe<IFlowRunLogComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: IFlowRunLogInput;
}


export interface IMutationCreateInvoiceArgs {
  condition?: InputMaybe<IInvoiceComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: IInvoiceInput;
}


export interface IMutationCreateOrgArgs {
  condition?: InputMaybe<IOrgComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: IOrgInput;
}


export interface IMutationCreatePermissionArgs {
  condition?: InputMaybe<IPermissionComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: IPermissionInput;
}


export interface IMutationCreatePriceArgs {
  condition?: InputMaybe<IPriceComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: IPriceInput;
}


export interface IMutationCreateProductArgs {
  condition?: InputMaybe<IProductComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: IProductInput;
}


export interface IMutationCreateProductBundleArgs {
  condition?: InputMaybe<IProductBundleComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: IProductBundleInput;
}


export interface IMutationCreatePublishRunArgs {
  condition?: InputMaybe<IPublishRunComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: IPublishRunInput;
}


export interface IMutationCreateRoleArgs {
  condition?: InputMaybe<IRoleComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: IRoleInput;
}


export interface IMutationCreateSchemaPromptArgs {
  condition?: InputMaybe<ISchemaPromptComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: ISchemaPromptInput;
}


export interface IMutationCreateSchemaTemplateArgs {
  condition?: InputMaybe<ISchemaTemplateComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: ISchemaTemplateInput;
}


export interface IMutationCreateSchemaTemplateLocalizationArgs {
  condition?: InputMaybe<ISchemaTemplateLocalizationComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: ISchemaTemplateLocalizationInput;
}


export interface IMutationCreateSubscriptionItemArgs {
  condition?: InputMaybe<ISubscriptionItemComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: ISubscriptionItemInput;
}


export interface IMutationCreateUsageRecordArgs {
  condition?: InputMaybe<IUsageRecordComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: IUsageRecordInput;
}


export interface IMutationCreateUserArgs {
  condition?: InputMaybe<IUserComparisonInput>;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  input: IUserInput;
}


export interface IMutationDeleteAccountCouponArgs {
  condition?: InputMaybe<IAccountCouponComparisonInput>;
  input: IAccountCouponDeleteInput;
}


export interface IMutationDeleteApiArgs {
  condition?: InputMaybe<IApiComparisonInput>;
  input: IApiDeleteInput;
}


export interface IMutationDeleteBenefitArgs {
  condition?: InputMaybe<IBenefitComparisonInput>;
  input: IBenefitDeleteInput;
}


export interface IMutationDeleteBillingAccountArgs {
  condition?: InputMaybe<IBillingAccountComparisonInput>;
  input: IBillingAccountDeleteInput;
}


export interface IMutationDeleteBundleSubscriptionArgs {
  condition?: InputMaybe<IBundleSubscriptionComparisonInput>;
  input: IBundleSubscriptionDeleteInput;
}


export interface IMutationDeleteCheckoutSessionArgs {
  condition?: InputMaybe<ICheckoutSessionComparisonInput>;
  input: ICheckoutSessionDeleteInput;
}


export interface IMutationDeleteConfigArgs {
  condition?: InputMaybe<IConfigComparisonInput>;
  input: IConfigDeleteInput;
}


export interface IMutationDeleteCouponRedemptionArgs {
  condition?: InputMaybe<ICouponRedemptionComparisonInput>;
  input: ICouponRedemptionDeleteInput;
}


export interface IMutationDeleteCustomerAppArgs {
  condition?: InputMaybe<ICustomerAppComparisonInput>;
  input: ICustomerAppDeleteInput;
}


export interface IMutationDeleteCustomerSecretArgs {
  condition?: InputMaybe<ICustomerSecretComparisonInput>;
  input: ICustomerSecretDeleteInput;
}


export interface IMutationDeleteFlowArgs {
  condition?: InputMaybe<IFlowComparisonInput>;
  input: IFlowDeleteInput;
}


export interface IMutationDeleteFlowRunArgs {
  condition?: InputMaybe<IFlowRunComparisonInput>;
  input: IFlowRunDeleteInput;
}


export interface IMutationDeleteFlowRunLogArgs {
  condition?: InputMaybe<IFlowRunLogComparisonInput>;
  input: IFlowRunLogDeleteInput;
}


export interface IMutationDeleteInvoiceArgs {
  condition?: InputMaybe<IInvoiceComparisonInput>;
  input: IInvoiceDeleteInput;
}


export interface IMutationDeleteOrgArgs {
  condition?: InputMaybe<IOrgComparisonInput>;
  input: IOrgDeleteInput;
}


export interface IMutationDeletePermissionArgs {
  condition?: InputMaybe<IPermissionComparisonInput>;
  input: IPermissionDeleteInput;
}


export interface IMutationDeletePriceArgs {
  condition?: InputMaybe<IPriceComparisonInput>;
  input: IPriceDeleteInput;
}


export interface IMutationDeleteProductArgs {
  condition?: InputMaybe<IProductComparisonInput>;
  input: IProductDeleteInput;
}


export interface IMutationDeleteProductBundleArgs {
  condition?: InputMaybe<IProductBundleComparisonInput>;
  input: IProductBundleDeleteInput;
}


export interface IMutationDeletePublishRunArgs {
  condition?: InputMaybe<IPublishRunComparisonInput>;
  input: IPublishRunDeleteInput;
}


export interface IMutationDeleteRoleArgs {
  condition?: InputMaybe<IRoleComparisonInput>;
  input: IRoleDeleteInput;
}


export interface IMutationDeleteSchemaPromptArgs {
  condition?: InputMaybe<ISchemaPromptComparisonInput>;
  input: ISchemaPromptDeleteInput;
}


export interface IMutationDeleteSchemaTemplateArgs {
  condition?: InputMaybe<ISchemaTemplateComparisonInput>;
  input: ISchemaTemplateDeleteInput;
}


export interface IMutationDeleteSchemaTemplateLocalizationArgs {
  condition?: InputMaybe<ISchemaTemplateLocalizationComparisonInput>;
  input: ISchemaTemplateLocalizationDeleteInput;
}


export interface IMutationDeleteSubscriptionItemArgs {
  condition?: InputMaybe<ISubscriptionItemComparisonInput>;
  input: ISubscriptionItemDeleteInput;
}


export interface IMutationDeleteUsageRecordArgs {
  condition?: InputMaybe<IUsageRecordComparisonInput>;
  input: IUsageRecordDeleteInput;
}


export interface IMutationDeleteUserArgs {
  condition?: InputMaybe<IUserComparisonInput>;
  input: IUserDeleteInput;
}


export interface IMutationUpdateAccountCouponArgs {
  condition?: InputMaybe<IAccountCouponComparisonInput>;
  input: IAccountCouponUpdateInput;
}


export interface IMutationUpdateApiArgs {
  condition?: InputMaybe<IApiComparisonInput>;
  input: IApiUpdateInput;
}


export interface IMutationUpdateBenefitArgs {
  condition?: InputMaybe<IBenefitComparisonInput>;
  input: IBenefitUpdateInput;
}


export interface IMutationUpdateBillingAccountArgs {
  condition?: InputMaybe<IBillingAccountComparisonInput>;
  input: IBillingAccountUpdateInput;
}


export interface IMutationUpdateBundleSubscriptionArgs {
  condition?: InputMaybe<IBundleSubscriptionComparisonInput>;
  input: IBundleSubscriptionUpdateInput;
}


export interface IMutationUpdateCheckoutSessionArgs {
  condition?: InputMaybe<ICheckoutSessionComparisonInput>;
  input: ICheckoutSessionUpdateInput;
}


export interface IMutationUpdateConfigArgs {
  condition?: InputMaybe<IConfigComparisonInput>;
  input: IConfigUpdateInput;
}


export interface IMutationUpdateCouponRedemptionArgs {
  condition?: InputMaybe<ICouponRedemptionComparisonInput>;
  input: ICouponRedemptionUpdateInput;
}


export interface IMutationUpdateCustomerAppArgs {
  condition?: InputMaybe<ICustomerAppComparisonInput>;
  input: ICustomerAppUpdateInput;
}


export interface IMutationUpdateCustomerSecretArgs {
  condition?: InputMaybe<ICustomerSecretComparisonInput>;
  input: ICustomerSecretUpdateInput;
}


export interface IMutationUpdateFlowArgs {
  condition?: InputMaybe<IFlowComparisonInput>;
  input: IFlowUpdateInput;
}


export interface IMutationUpdateFlowRunArgs {
  condition?: InputMaybe<IFlowRunComparisonInput>;
  input: IFlowRunUpdateInput;
}


export interface IMutationUpdateFlowRunLogArgs {
  condition?: InputMaybe<IFlowRunLogComparisonInput>;
  input: IFlowRunLogUpdateInput;
}


export interface IMutationUpdateInvoiceArgs {
  condition?: InputMaybe<IInvoiceComparisonInput>;
  input: IInvoiceUpdateInput;
}


export interface IMutationUpdateOrgArgs {
  condition?: InputMaybe<IOrgComparisonInput>;
  input: IOrgUpdateInput;
}


export interface IMutationUpdatePermissionArgs {
  condition?: InputMaybe<IPermissionComparisonInput>;
  input: IPermissionUpdateInput;
}


export interface IMutationUpdatePriceArgs {
  condition?: InputMaybe<IPriceComparisonInput>;
  input: IPriceUpdateInput;
}


export interface IMutationUpdateProductArgs {
  condition?: InputMaybe<IProductComparisonInput>;
  input: IProductUpdateInput;
}


export interface IMutationUpdateProductBundleArgs {
  condition?: InputMaybe<IProductBundleComparisonInput>;
  input: IProductBundleUpdateInput;
}


export interface IMutationUpdatePublishRunArgs {
  condition?: InputMaybe<IPublishRunComparisonInput>;
  input: IPublishRunUpdateInput;
}


export interface IMutationUpdateRoleArgs {
  condition?: InputMaybe<IRoleComparisonInput>;
  input: IRoleUpdateInput;
}


export interface IMutationUpdateSchemaPromptArgs {
  condition?: InputMaybe<ISchemaPromptComparisonInput>;
  input: ISchemaPromptUpdateInput;
}


export interface IMutationUpdateSchemaTemplateArgs {
  condition?: InputMaybe<ISchemaTemplateComparisonInput>;
  input: ISchemaTemplateUpdateInput;
}


export interface IMutationUpdateSchemaTemplateLocalizationArgs {
  condition?: InputMaybe<ISchemaTemplateLocalizationComparisonInput>;
  input: ISchemaTemplateLocalizationUpdateInput;
}


export interface IMutationUpdateSubscriptionItemArgs {
  condition?: InputMaybe<ISubscriptionItemComparisonInput>;
  input: ISubscriptionItemUpdateInput;
}


export interface IMutationUpdateUsageRecordArgs {
  condition?: InputMaybe<IUsageRecordComparisonInput>;
  input: IUsageRecordUpdateInput;
}


export interface IMutationUpdateUserArgs {
  condition?: InputMaybe<IUserComparisonInput>;
  input: IUserUpdateInput;
}


export interface IMutationUploadInlineS3ObjectArgs {
  input: IInlineS3ObjectInput;
}


export interface IMutationUploadS3ObjectIntentArgs {
  input: IS3ObjectInput;
}

export interface INode {
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
}

export interface IOrg extends INode {
  __typename?: 'Org';
  apiConnection?: Maybe<IOrgApisConnection>;
  awsAccountId?: Maybe<Scalars['ID']['output']>;
  billingAccountConnection?: Maybe<IOrgBillingAccountsConnection>;
  bundleSubscriptionConnection?: Maybe<IOrgBundleSubscriptionsConnection>;
  checkoutSessionConnection?: Maybe<IOrgCheckoutSessionsConnection>;
  createdAt: Scalars['String']['output'];
  dataProcessingCategories?: Maybe<Scalars['AWSJSON']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  roleConnection?: Maybe<IOrgRolesConnection>;
  updatedAt?: Maybe<Scalars['String']['output']>;
}


export interface IOrgApiConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IApiComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IOrgBillingAccountConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IBillingAccountComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IOrgBundleSubscriptionConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IBundleSubscriptionComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IOrgCheckoutSessionConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ICheckoutSessionComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IOrgRoleConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IRoleComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}

export interface IOrgApisConnection {
  __typename?: 'OrgApisConnection';
  items?: Maybe<Array<Maybe<IApi>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IOrgBillingAccountsConnection {
  __typename?: 'OrgBillingAccountsConnection';
  items?: Maybe<Array<Maybe<IBillingAccount>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IOrgBundleSubscriptionsConnection {
  __typename?: 'OrgBundleSubscriptionsConnection';
  items?: Maybe<Array<Maybe<IBundleSubscription>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IOrgCheckoutSessionsConnection {
  __typename?: 'OrgCheckoutSessionsConnection';
  items?: Maybe<Array<Maybe<ICheckoutSession>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IOrgComparisonInput {
  and?: InputMaybe<Array<InputMaybe<IOrgComparisonInput>>>;
  awsAccountId?: InputMaybe<IIdComparisonInput>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  name?: InputMaybe<IStringComparisonInput>;
  not?: InputMaybe<IOrgComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<IOrgComparisonInput>>>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface IOrgDeleteInput {
  id: Scalars['ID']['input'];
}

export interface IOrgInput {
  awsAccountId?: InputMaybe<Scalars['ID']['input']>;
  dataProcessingCategories?: InputMaybe<Scalars['AWSJSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
}

export interface IOrgRolesConnection {
  __typename?: 'OrgRolesConnection';
  items?: Maybe<Array<Maybe<IRole>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IOrgUpdateInput {
  awsAccountId?: InputMaybe<Scalars['ID']['input']>;
  dataProcessingCategories?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface IOrgsConnection {
  __typename?: 'OrgsConnection';
  items?: Maybe<Array<Maybe<IOrg>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export enum ParentKey {
  FIRST = 'FIRST',
  SECOND = 'SECOND'
}

export interface IPermission extends INode {
  __typename?: 'Permission';
  actions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt: Scalars['String']['output'];
  entity?: Maybe<TrustedEntityType>;
  id: Scalars['ID']['output'];
  roleType: RoleType;
  type?: Maybe<PermissionType>;
  updatedAt?: Maybe<Scalars['String']['output']>;
}

export interface IPermissionComparisonInput {
  actions?: InputMaybe<IStringComparisonInput>;
  and?: InputMaybe<Array<InputMaybe<IPermissionComparisonInput>>>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  entity?: InputMaybe<ITrustedEntityTypeComparisonInput>;
  not?: InputMaybe<IPermissionComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<IPermissionComparisonInput>>>;
  roleType?: InputMaybe<IRoleTypeComparisonInput>;
  type?: InputMaybe<IPermissionTypeComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface IPermissionDeleteInput {
  id: Scalars['ID']['input'];
}

export interface IPermissionInput {
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entity?: InputMaybe<TrustedEntityType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  roleType: RoleType;
  type?: InputMaybe<PermissionType>;
}

export enum PermissionType {
  CAN_DELETE = 'CAN_DELETE',
  CAN_MANAGE = 'CAN_MANAGE',
  CAN_VIEW = 'CAN_VIEW'
}

export interface IPermissionTypeComparisonInput {
  eq?: InputMaybe<PermissionType>;
  ne?: InputMaybe<PermissionType>;
}

export interface IPermissionUpdateInput {
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entity?: InputMaybe<TrustedEntityType>;
  id: Scalars['ID']['input'];
  roleType?: InputMaybe<RoleType>;
  type?: InputMaybe<PermissionType>;
}

export interface IPermissionsConnection {
  __typename?: 'PermissionsConnection';
  items?: Maybe<Array<Maybe<IPermission>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IPrice extends INode {
  __typename?: 'Price';
  billingInterval?: Maybe<BillingInterval>;
  billingScheme?: Maybe<BillingScheme>;
  createdAt: Scalars['String']['output'];
  currency?: Maybe<CurrencyType>;
  id: Scalars['ID']['output'];
  paymentProviderId?: Maybe<Scalars['ID']['output']>;
  paymentProviderProductId?: Maybe<Scalars['ID']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productName: Scalars['String']['output'];
  recurring?: Maybe<Scalars['Boolean']['output']>;
  reservedUnits?: Maybe<Scalars['Int']['output']>;
  tiers?: Maybe<Scalars['AWSJSON']['output']>;
  unitAmount?: Maybe<Scalars['Int']['output']>;
  unitType?: Maybe<UnitType>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  usageType?: Maybe<UsageType>;
}

export interface IPriceComparisonInput {
  and?: InputMaybe<Array<InputMaybe<IPriceComparisonInput>>>;
  billingInterval?: InputMaybe<IBillingIntervalComparisonInput>;
  billingScheme?: InputMaybe<IBillingSchemeComparisonInput>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  currency?: InputMaybe<ICurrencyTypeComparisonInput>;
  not?: InputMaybe<IPriceComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<IPriceComparisonInput>>>;
  paymentProviderId?: InputMaybe<IIdComparisonInput>;
  paymentProviderProductId?: InputMaybe<IIdComparisonInput>;
  price?: InputMaybe<IFloatComparisonInput>;
  productName?: InputMaybe<IStringComparisonInput>;
  recurring?: InputMaybe<IBooleanComparisonInput>;
  reservedUnits?: InputMaybe<IIntComparisonInput>;
  unitAmount?: InputMaybe<IIntComparisonInput>;
  unitType?: InputMaybe<IUnitTypeComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
  usageType?: InputMaybe<IUsageTypeComparisonInput>;
}

export interface IPriceDeleteInput {
  id: Scalars['ID']['input'];
}

export interface IPriceInput {
  billingInterval?: InputMaybe<BillingInterval>;
  billingScheme?: InputMaybe<BillingScheme>;
  currency?: InputMaybe<CurrencyType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderId?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderProductId: Scalars['ID']['input'];
  price: Scalars['Float']['input'];
  productName: Scalars['String']['input'];
  recurring: Scalars['Boolean']['input'];
  reservedUnits: Scalars['Int']['input'];
  tiers?: InputMaybe<Scalars['AWSJSON']['input']>;
  unitAmount: Scalars['Int']['input'];
  unitType?: InputMaybe<UnitType>;
  usageType: UsageType;
}

export interface IPriceUpdateInput {
  billingInterval?: InputMaybe<BillingInterval>;
  billingScheme?: InputMaybe<BillingScheme>;
  currency?: InputMaybe<CurrencyType>;
  id: Scalars['ID']['input'];
  paymentProviderId?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderProductId?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
  reservedUnits?: InputMaybe<Scalars['Int']['input']>;
  tiers?: InputMaybe<Scalars['AWSJSON']['input']>;
  unitAmount?: InputMaybe<Scalars['Int']['input']>;
  unitType?: InputMaybe<UnitType>;
  usageType?: InputMaybe<UsageType>;
}

export interface IPricesConnection {
  __typename?: 'PricesConnection';
  items?: Maybe<Array<Maybe<IPrice>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IProduct extends INode {
  __typename?: 'Product';
  benefitConnection?: Maybe<IProductBenefitsConnection>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  paymentProviderId?: Maybe<Scalars['ID']['output']>;
  priceConnection?: Maybe<IProductPricesConnection>;
  productBundleType: BundleType;
  rank?: Maybe<Scalars['Int']['output']>;
  selectedPricingIndex?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<ProductType>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  usageType?: Maybe<UsageType>;
}


export interface IProductBenefitConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IBenefitComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IProductPriceConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IPriceComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}

export interface IProductBenefitsConnection {
  __typename?: 'ProductBenefitsConnection';
  items?: Maybe<Array<Maybe<IBenefit>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IProductBundle extends INode {
  __typename?: 'ProductBundle';
  createdAt: Scalars['String']['output'];
  freeTiers?: Maybe<Scalars['AWSJSON']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  productConnection?: Maybe<IProductBundleProductsConnection>;
  rank?: Maybe<Scalars['Int']['output']>;
  type: BundleType;
  updatedAt?: Maybe<Scalars['String']['output']>;
}


export interface IProductBundleProductConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IProductComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}

export interface IProductBundleComparisonInput {
  and?: InputMaybe<Array<InputMaybe<IProductBundleComparisonInput>>>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  name?: InputMaybe<IStringComparisonInput>;
  not?: InputMaybe<IProductBundleComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<IProductBundleComparisonInput>>>;
  rank?: InputMaybe<IIntComparisonInput>;
  type?: InputMaybe<IBundleTypeComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface IProductBundleDeleteInput {
  id: Scalars['ID']['input'];
}

export interface IProductBundleInput {
  freeTiers?: InputMaybe<Scalars['AWSJSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  rank: Scalars['Int']['input'];
  type: BundleType;
}

export interface IProductBundleProductsConnection {
  __typename?: 'ProductBundleProductsConnection';
  items?: Maybe<Array<Maybe<IProduct>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IProductBundleUpdateInput {
  freeTiers?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<BundleType>;
}

export interface IProductBundlesConnection {
  __typename?: 'ProductBundlesConnection';
  items?: Maybe<Array<Maybe<IProductBundle>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IProductComparisonInput {
  and?: InputMaybe<Array<InputMaybe<IProductComparisonInput>>>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  description?: InputMaybe<IStringComparisonInput>;
  displayName?: InputMaybe<IStringComparisonInput>;
  name?: InputMaybe<IStringComparisonInput>;
  not?: InputMaybe<IProductComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<IProductComparisonInput>>>;
  paymentProviderId?: InputMaybe<IIdComparisonInput>;
  productBundleType?: InputMaybe<IBundleTypeComparisonInput>;
  rank?: InputMaybe<IIntComparisonInput>;
  selectedPricingIndex?: InputMaybe<IIntComparisonInput>;
  type?: InputMaybe<IProductTypeComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
  usageType?: InputMaybe<IUsageTypeComparisonInput>;
}

export interface IProductDeleteInput {
  id: Scalars['ID']['input'];
  paymentProviderId: Scalars['ID']['input'];
}

export interface IProductInput {
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentProviderId: Scalars['ID']['input'];
  productBundleType: BundleType;
  rank: Scalars['Int']['input'];
  selectedPricingIndex: Scalars['Int']['input'];
  type?: InputMaybe<ProductType>;
  usageType: UsageType;
}

export interface IProductPricesConnection {
  __typename?: 'ProductPricesConnection';
  items?: Maybe<Array<Maybe<IPrice>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export enum ProductType {
  ADDON = 'ADDON',
  BASE = 'BASE',
  BUNDLE = 'BUNDLE'
}

export interface IProductTypeComparisonInput {
  eq?: InputMaybe<ProductType>;
  ne?: InputMaybe<ProductType>;
}

export interface IProductUpdateInput {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  paymentProviderId: Scalars['ID']['input'];
  productBundleType?: InputMaybe<BundleType>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  selectedPricingIndex?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ProductType>;
  usageType?: InputMaybe<UsageType>;
}

export interface IProductsConnection {
  __typename?: 'ProductsConnection';
  items?: Maybe<Array<Maybe<IProduct>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IPublishRun extends INode {
  __typename?: 'PublishRun';
  apiId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  initState?: Maybe<PublishingState>;
  schema?: Maybe<Scalars['AWSJSON']['output']>;
  schemaVersion?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<PublishRunStatus>;
  updatedAt?: Maybe<Scalars['String']['output']>;
}

export interface IPublishRunComparisonInput {
  and?: InputMaybe<Array<InputMaybe<IPublishRunComparisonInput>>>;
  apiId?: InputMaybe<IIdComparisonInput>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  initState?: InputMaybe<IPublishingStateComparisonInput>;
  not?: InputMaybe<IPublishRunComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<IPublishRunComparisonInput>>>;
  schemaVersion?: InputMaybe<IIntComparisonInput>;
  status?: InputMaybe<IPublishRunStatusComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface IPublishRunDeleteInput {
  id: Scalars['ID']['input'];
}

export interface IPublishRunInput {
  apiId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  initState?: InputMaybe<PublishingState>;
  schema: Scalars['AWSJSON']['input'];
  schemaVersion: Scalars['Int']['input'];
  status?: InputMaybe<PublishRunStatus>;
}

export enum PublishRunStatus {
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCEEDED = 'SUCCEEDED'
}

export interface IPublishRunStatusComparisonInput {
  eq?: InputMaybe<PublishRunStatus>;
  ne?: InputMaybe<PublishRunStatus>;
}

export interface IPublishRunUpdateInput {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  initState?: InputMaybe<PublishingState>;
  schema?: InputMaybe<Scalars['AWSJSON']['input']>;
  schemaVersion?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PublishRunStatus>;
}

export interface IPublishRunsConnection {
  __typename?: 'PublishRunsConnection';
  items?: Maybe<Array<Maybe<IPublishRun>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export enum PublishingState {
  IMPORTED = 'IMPORTED',
  INITIALIZED = 'INITIALIZED',
  PUBLISHED = 'PUBLISHED',
  PUBLISHING = 'PUBLISHING',
  PUBLISHING_FAILED = 'PUBLISHING_FAILED',
  PUBLISHING_PREPARE = 'PUBLISHING_PREPARE',
  PUBLISHING_RESOLVERS = 'PUBLISHING_RESOLVERS',
  PUBLISHING_SCHEMA = 'PUBLISHING_SCHEMA'
}

export interface IPublishingStateComparisonInput {
  eq?: InputMaybe<PublishingState>;
  ne?: InputMaybe<PublishingState>;
}

export interface IQuery {
  __typename?: 'Query';
  accountCoupon?: Maybe<IAccountCoupon>;
  api?: Maybe<IApi>;
  batchGetAccountCoupon?: Maybe<Array<Maybe<IAccountCoupon>>>;
  batchGetApi?: Maybe<Array<Maybe<IApi>>>;
  batchGetBenefit?: Maybe<Array<Maybe<IBenefit>>>;
  batchGetBillingAccount?: Maybe<Array<Maybe<IBillingAccount>>>;
  batchGetBundleSubscription?: Maybe<Array<Maybe<IBundleSubscription>>>;
  batchGetCheckoutSession?: Maybe<Array<Maybe<ICheckoutSession>>>;
  batchGetConfig?: Maybe<Array<Maybe<IConfig>>>;
  batchGetCouponRedemption?: Maybe<Array<Maybe<ICouponRedemption>>>;
  batchGetCustomerApp?: Maybe<Array<Maybe<ICustomerApp>>>;
  batchGetCustomerSecret?: Maybe<Array<Maybe<ICustomerSecret>>>;
  batchGetFlow?: Maybe<Array<Maybe<IFlow>>>;
  batchGetFlowRun?: Maybe<Array<Maybe<IFlowRun>>>;
  batchGetFlowRunLog?: Maybe<Array<Maybe<IFlowRunLog>>>;
  batchGetInvoice?: Maybe<Array<Maybe<IInvoice>>>;
  batchGetOrg?: Maybe<Array<Maybe<IOrg>>>;
  batchGetPermission?: Maybe<Array<Maybe<IPermission>>>;
  batchGetPrice?: Maybe<Array<Maybe<IPrice>>>;
  batchGetProduct?: Maybe<Array<Maybe<IProduct>>>;
  batchGetProductBundle?: Maybe<Array<Maybe<IProductBundle>>>;
  batchGetPublishRun?: Maybe<Array<Maybe<IPublishRun>>>;
  batchGetRole?: Maybe<Array<Maybe<IRole>>>;
  batchGetSchemaPrompt?: Maybe<Array<Maybe<ISchemaPrompt>>>;
  batchGetSchemaTemplate?: Maybe<Array<Maybe<ISchemaTemplate>>>;
  batchGetSchemaTemplateLocalization?: Maybe<Array<Maybe<ISchemaTemplateLocalization>>>;
  batchGetSubscriptionItem?: Maybe<Array<Maybe<ISubscriptionItem>>>;
  batchGetUsageRecord?: Maybe<Array<Maybe<IUsageRecord>>>;
  batchGetUser?: Maybe<Array<Maybe<IUser>>>;
  benefit?: Maybe<IBenefit>;
  billingAccount?: Maybe<IBillingAccount>;
  bundleSubscription?: Maybe<IBundleSubscription>;
  checkoutSession?: Maybe<ICheckoutSession>;
  config?: Maybe<IConfig>;
  couponRedemption?: Maybe<ICouponRedemption>;
  customerApp?: Maybe<ICustomerApp>;
  customerSecret?: Maybe<ICustomerSecret>;
  flow?: Maybe<IFlow>;
  flowRun?: Maybe<IFlowRun>;
  flowRunLog?: Maybe<IFlowRunLog>;
  invoice?: Maybe<IInvoice>;
  listAccountCoupons?: Maybe<IAccountCouponsConnection>;
  listAccountCouponsByConfig?: Maybe<IAccountCouponsConnection>;
  listApis?: Maybe<IApisConnection>;
  listApisByOrg?: Maybe<IApisConnection>;
  listBenefits?: Maybe<IBenefitsConnection>;
  listBenefitsByProduct?: Maybe<IBenefitsConnection>;
  listBillingAccounts?: Maybe<IBillingAccountsConnection>;
  listBillingAccountsByOrg?: Maybe<IBillingAccountsConnection>;
  listBundleSubscriptions?: Maybe<IBundleSubscriptionsConnection>;
  listBundleSubscriptionsByApi?: Maybe<IBundleSubscriptionsConnection>;
  listBundleSubscriptionsByOrg?: Maybe<IBundleSubscriptionsConnection>;
  listCheckoutSessions?: Maybe<ICheckoutSessionsConnection>;
  listCheckoutSessionsByApi?: Maybe<ICheckoutSessionsConnection>;
  listCheckoutSessionsByOrg?: Maybe<ICheckoutSessionsConnection>;
  listConfigs?: Maybe<IConfigsConnection>;
  listCouponRedemptions?: Maybe<ICouponRedemptionsConnection>;
  listCouponRedemptionsByAccountCoupon?: Maybe<ICouponRedemptionsConnection>;
  listCustomerApps?: Maybe<ICustomerAppsConnection>;
  listCustomerAppsByApi?: Maybe<ICustomerAppsConnection>;
  listCustomerSecrets?: Maybe<ICustomerSecretsConnection>;
  listCustomerSecretsByApi?: Maybe<ICustomerSecretsConnection>;
  listFlowRunLogs?: Maybe<IFlowRunLogsConnection>;
  listFlowRunLogsByFlowRun?: Maybe<IFlowRunLogsConnection>;
  listFlowRuns?: Maybe<IFlowRunsConnection>;
  listFlowRunsByFlow?: Maybe<IFlowRunsConnection>;
  listFlows?: Maybe<IFlowsConnection>;
  listFlowsByApi?: Maybe<IFlowsConnection>;
  listInvoices?: Maybe<IInvoicesConnection>;
  listInvoicesByBillingAccount?: Maybe<IInvoicesConnection>;
  listOrgs?: Maybe<IOrgsConnection>;
  listPermissions?: Maybe<IPermissionsConnection>;
  listPermissionsByRole?: Maybe<IPermissionsConnection>;
  listPrices?: Maybe<IPricesConnection>;
  listPricesByProduct?: Maybe<IPricesConnection>;
  listProductBundles?: Maybe<IProductBundlesConnection>;
  listProducts?: Maybe<IProductsConnection>;
  listProductsByProductBundle?: Maybe<IProductsConnection>;
  listPublishRuns?: Maybe<IPublishRunsConnection>;
  listPublishRunsByApi?: Maybe<IPublishRunsConnection>;
  listRoles?: Maybe<IRolesConnection>;
  listRolesByOrg?: Maybe<IRolesConnection>;
  listRolesByUser?: Maybe<IRolesConnection>;
  listSchemaPrompts?: Maybe<ISchemaPromptsConnection>;
  listSchemaPromptsByApi?: Maybe<ISchemaPromptsConnection>;
  listSchemaPromptsByUser?: Maybe<ISchemaPromptsConnection>;
  listSchemaTemplateLocalizations?: Maybe<ISchemaTemplateLocalizationsConnection>;
  listSchemaTemplateLocalizationsBySchemaTemplate?: Maybe<ISchemaTemplateLocalizationsConnection>;
  listSchemaTemplates?: Maybe<ISchemaTemplatesConnection>;
  listSubscriptionItems?: Maybe<ISubscriptionItemsConnection>;
  listSubscriptionItemsByBundleSubscription?: Maybe<ISubscriptionItemsConnection>;
  listUsageRecords?: Maybe<IUsageRecordsConnection>;
  listUsageRecordsBySubscriptionItem?: Maybe<IUsageRecordsConnection>;
  listUsers?: Maybe<IUsersConnection>;
  org?: Maybe<IOrg>;
  permission?: Maybe<IPermission>;
  price?: Maybe<IPrice>;
  product?: Maybe<IProduct>;
  productBundle?: Maybe<IProductBundle>;
  publishRun?: Maybe<IPublishRun>;
  role?: Maybe<IRole>;
  schemaPrompt?: Maybe<ISchemaPrompt>;
  schemaTemplate?: Maybe<ISchemaTemplate>;
  schemaTemplateLocalization?: Maybe<ISchemaTemplateLocalization>;
  subscriptionItem?: Maybe<ISubscriptionItem>;
  usageRecord?: Maybe<IUsageRecord>;
  user?: Maybe<IUser>;
}


export interface IQueryAccountCouponArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryApiArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryBatchGetAccountCouponArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetApiArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetBenefitArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetBillingAccountArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetBundleSubscriptionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetCheckoutSessionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetConfigArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetCouponRedemptionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetCustomerAppArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetCustomerSecretArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetFlowArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetFlowRunArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetFlowRunLogArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetInvoiceArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetOrgArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetPermissionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetPriceArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetProductArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetProductBundleArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetPublishRunArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetRoleArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetSchemaPromptArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetSchemaTemplateArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetSchemaTemplateLocalizationArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetSubscriptionItemArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetUsageRecordArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBatchGetUserArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface IQueryBenefitArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryBillingAccountArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryBundleSubscriptionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryCheckoutSessionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryConfigArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryCouponRedemptionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryCustomerAppArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryCustomerSecretArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryFlowArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryFlowRunArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryFlowRunLogArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryInvoiceArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryListAccountCouponsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IAccountCouponComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListAccountCouponsByConfigArgs {
  configRegion: AwsRegion;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IAccountCouponComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListApisArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IApiComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListApisByOrgArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IApiComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['ID']['input'];
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListBenefitsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IBenefitComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListBenefitsByProductArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IBenefitComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  productName: Scalars['String']['input'];
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListBillingAccountsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IBillingAccountComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListBillingAccountsByOrgArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IBillingAccountComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['ID']['input'];
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListBundleSubscriptionsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IBundleSubscriptionComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListBundleSubscriptionsByApiArgs {
  apiId: Scalars['ID']['input'];
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IBundleSubscriptionComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListBundleSubscriptionsByOrgArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IBundleSubscriptionComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['ID']['input'];
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListCheckoutSessionsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ICheckoutSessionComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListCheckoutSessionsByApiArgs {
  apiId: Scalars['ID']['input'];
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ICheckoutSessionComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListCheckoutSessionsByOrgArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ICheckoutSessionComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['ID']['input'];
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListConfigsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IConfigComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListCouponRedemptionsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ICouponRedemptionComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListCouponRedemptionsByAccountCouponArgs {
  accountCouponConfigType: ConfigType;
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ICouponRedemptionComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListCustomerAppsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ICustomerAppComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListCustomerAppsByApiArgs {
  apiId: Scalars['ID']['input'];
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ICustomerAppComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListCustomerSecretsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ICustomerSecretComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListCustomerSecretsByApiArgs {
  apiId: Scalars['ID']['input'];
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ICustomerSecretComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListFlowRunLogsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IFlowRunLogComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListFlowRunLogsByFlowRunArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IFlowRunLogComparisonInput>;
  flowRunId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListFlowRunsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IFlowRunComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListFlowRunsByFlowArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IFlowRunComparisonInput>;
  flowId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListFlowsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IFlowComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListFlowsByApiArgs {
  apiId: Scalars['ID']['input'];
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IFlowComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListInvoicesArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IInvoiceComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListInvoicesByBillingAccountArgs {
  billingAccountPaymentProviderId: Scalars['ID']['input'];
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IInvoiceComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListOrgsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IOrgComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListPermissionsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IPermissionComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListPermissionsByRoleArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IPermissionComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  roleType: RoleType;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListPricesArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IPriceComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListPricesByProductArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IPriceComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  productName: Scalars['String']['input'];
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListProductBundlesArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IProductBundleComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListProductsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IProductComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListProductsByProductBundleArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IProductComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  productBundleType: BundleType;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListPublishRunsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IPublishRunComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListPublishRunsByApiArgs {
  apiId: Scalars['ID']['input'];
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IPublishRunComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListRolesArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IRoleComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListRolesByOrgArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IRoleComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['ID']['input'];
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListRolesByUserArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IRoleComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
  userEmail: Scalars['AWSEmail']['input'];
}


export interface IQueryListSchemaPromptsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ISchemaPromptComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListSchemaPromptsByApiArgs {
  apiId: Scalars['ID']['input'];
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ISchemaPromptComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListSchemaPromptsByUserArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ISchemaPromptComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
  userEmail: Scalars['AWSEmail']['input'];
}


export interface IQueryListSchemaTemplateLocalizationsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ISchemaTemplateLocalizationComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListSchemaTemplateLocalizationsBySchemaTemplateArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ISchemaTemplateLocalizationComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  schemaTemplateId: Scalars['ID']['input'];
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListSchemaTemplatesArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ISchemaTemplateComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListSubscriptionItemsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ISubscriptionItemComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListSubscriptionItemsByBundleSubscriptionArgs {
  bundleSubscriptionId: Scalars['ID']['input'];
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ISubscriptionItemComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListUsageRecordsArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IUsageRecordComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryListUsageRecordsBySubscriptionItemArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IUsageRecordComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
  subscriptionItemId: Scalars['ID']['input'];
}


export interface IQueryListUsersArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IUserComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IQueryOrgArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryPermissionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryPriceArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryProductArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryProductBundleArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryPublishRunArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryRoleArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQuerySchemaPromptArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQuerySchemaTemplateArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQuerySchemaTemplateLocalizationArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQuerySubscriptionItemArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryUsageRecordArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}


export interface IQueryUserArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
}

export interface IRangeComparisonInput {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
}

export enum RedemptionStatus {
  INVALID = 'INVALID',
  USED = 'USED',
  VALID = 'VALID'
}

export interface IRedemptionStatusComparisonInput {
  eq?: InputMaybe<RedemptionStatus>;
  ne?: InputMaybe<RedemptionStatus>;
}

export interface IRole extends INode {
  __typename?: 'Role';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastSignInAt?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['ID']['output']>;
  permissionConnection?: Maybe<IRolePermissionsConnection>;
  type: RoleType;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userEmail: Scalars['AWSEmail']['output'];
}


export interface IRolePermissionConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IPermissionComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}

export interface IRoleComparisonInput {
  and?: InputMaybe<Array<InputMaybe<IRoleComparisonInput>>>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  lastSignInAt?: InputMaybe<IStringComparisonInput>;
  not?: InputMaybe<IRoleComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<IRoleComparisonInput>>>;
  orgId?: InputMaybe<IIdComparisonInput>;
  type?: InputMaybe<IRoleTypeComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
  userEmail?: InputMaybe<IStringComparisonInput>;
}

export interface IRoleDeleteInput {
  id: Scalars['ID']['input'];
}

export interface IRoleInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  lastSignInAt?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['ID']['input'];
  type: RoleType;
  userEmail: Scalars['AWSEmail']['input'];
}

export interface IRolePermissionsConnection {
  __typename?: 'RolePermissionsConnection';
  items?: Maybe<Array<Maybe<IPermission>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export enum RoleType {
  ADMIN = 'ADMIN',
  CONTENT = 'CONTENT',
  DEV = 'DEV',
  GUEST = 'GUEST',
  NONE = 'NONE',
  OWNER = 'OWNER',
  SUPERUSER = 'SUPERUSER',
  SUPPORT = 'SUPPORT'
}

export interface IRoleTypeComparisonInput {
  eq?: InputMaybe<RoleType>;
  ne?: InputMaybe<RoleType>;
}

export interface IRoleUpdateInput {
  id: Scalars['ID']['input'];
  lastSignInAt?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<RoleType>;
  userEmail?: InputMaybe<Scalars['AWSEmail']['input']>;
}

export interface IRolesConnection {
  __typename?: 'RolesConnection';
  items?: Maybe<Array<Maybe<IRole>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IS3Object {
  __typename?: 'S3Object';
  bucket: Scalars['String']['output'];
  etag?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  url?: Maybe<Scalars['AWSURL']['output']>;
}

export interface IS3ObjectInput {
  accessControl?: InputMaybe<AccessControlType>;
  bucket: Scalars['String']['input'];
  key: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
}

export interface IS3ObjectUploadIntent {
  __typename?: 'S3ObjectUploadIntent';
  bucket: Scalars['String']['output'];
  key: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  uploadUrl?: Maybe<Scalars['AWSURL']['output']>;
  url?: Maybe<Scalars['AWSURL']['output']>;
}

export interface ISchemaPrompt extends INode {
  __typename?: 'SchemaPrompt';
  apiId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
  schema?: Maybe<Scalars['AWSJSON']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userEmail: Scalars['AWSEmail']['output'];
}

export interface ISchemaPromptComparisonInput {
  and?: InputMaybe<Array<InputMaybe<ISchemaPromptComparisonInput>>>;
  apiId?: InputMaybe<IIdComparisonInput>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  error?: InputMaybe<IStringComparisonInput>;
  not?: InputMaybe<ISchemaPromptComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<ISchemaPromptComparisonInput>>>;
  prompt?: InputMaybe<IStringComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
  userEmail?: InputMaybe<IStringComparisonInput>;
}

export interface ISchemaPromptDeleteInput {
  id: Scalars['ID']['input'];
}

export interface ISchemaPromptInput {
  apiId: Scalars['ID']['input'];
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  prompt: Scalars['String']['input'];
  schema?: InputMaybe<Scalars['AWSJSON']['input']>;
  userEmail: Scalars['AWSEmail']['input'];
}

export interface ISchemaPromptUpdateInput {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['AWSJSON']['input']>;
  userEmail?: InputMaybe<Scalars['AWSEmail']['input']>;
}

export interface ISchemaPromptsConnection {
  __typename?: 'SchemaPromptsConnection';
  items?: Maybe<Array<Maybe<ISchemaPrompt>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface ISchemaTemplate extends INode {
  __typename?: 'SchemaTemplate';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  schema?: Maybe<Scalars['AWSJSON']['output']>;
  schemaTemplateLocalizationConnection?: Maybe<ISchemaTemplateSchemaTemplateLocalizationsConnection>;
  state?: Maybe<SchemaTemplateState>;
  updatedAt?: Maybe<Scalars['String']['output']>;
}


export interface ISchemaTemplateSchemaTemplateLocalizationConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ISchemaTemplateLocalizationComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}

export interface ISchemaTemplateComparisonInput {
  and?: InputMaybe<Array<InputMaybe<ISchemaTemplateComparisonInput>>>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  not?: InputMaybe<ISchemaTemplateComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<ISchemaTemplateComparisonInput>>>;
  state?: InputMaybe<ISchemaTemplateStateComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface ISchemaTemplateDeleteInput {
  id: Scalars['ID']['input'];
}

export interface ISchemaTemplateInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  schema?: InputMaybe<Scalars['AWSJSON']['input']>;
  state?: InputMaybe<SchemaTemplateState>;
}

export interface ISchemaTemplateLocalization extends INode {
  __typename?: 'SchemaTemplateLocalization';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lang?: Maybe<LanguageCode>;
  name?: Maybe<Scalars['String']['output']>;
  schemaTemplateId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
}

export interface ISchemaTemplateLocalizationComparisonInput {
  and?: InputMaybe<Array<InputMaybe<ISchemaTemplateLocalizationComparisonInput>>>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  description?: InputMaybe<IStringComparisonInput>;
  lang?: InputMaybe<ILanguageCodeComparisonInput>;
  name?: InputMaybe<IStringComparisonInput>;
  not?: InputMaybe<ISchemaTemplateLocalizationComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<ISchemaTemplateLocalizationComparisonInput>>>;
  schemaTemplateId?: InputMaybe<IIdComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface ISchemaTemplateLocalizationDeleteInput {
  id: Scalars['ID']['input'];
}

export interface ISchemaTemplateLocalizationInput {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lang: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
  schemaTemplateId: Scalars['ID']['input'];
}

export interface ISchemaTemplateLocalizationUpdateInput {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lang?: InputMaybe<LanguageCode>;
  name?: InputMaybe<Scalars['String']['input']>;
  schemaTemplateId?: InputMaybe<Scalars['ID']['input']>;
}

export interface ISchemaTemplateLocalizationsConnection {
  __typename?: 'SchemaTemplateLocalizationsConnection';
  items?: Maybe<Array<Maybe<ISchemaTemplateLocalization>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface ISchemaTemplateSchemaTemplateLocalizationsConnection {
  __typename?: 'SchemaTemplateSchemaTemplateLocalizationsConnection';
  items?: Maybe<Array<Maybe<ISchemaTemplateLocalization>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export enum SchemaTemplateState {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export interface ISchemaTemplateStateComparisonInput {
  eq?: InputMaybe<SchemaTemplateState>;
  ne?: InputMaybe<SchemaTemplateState>;
}

export interface ISchemaTemplateUpdateInput {
  id: Scalars['ID']['input'];
  schema?: InputMaybe<Scalars['AWSJSON']['input']>;
  state?: InputMaybe<SchemaTemplateState>;
}

export interface ISchemaTemplatesConnection {
  __typename?: 'SchemaTemplatesConnection';
  items?: Maybe<Array<Maybe<ISchemaTemplate>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface ISizeComparisonInput {
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
}

export enum SortOrderType {
  ASC = 'ASC',
  DESC = 'DESC'
}

export interface IStringComparisonInput {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ComparisonAttributeType>;
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<ISizeComparisonInput>;
}

export interface ISubscription {
  __typename?: 'Subscription';
  onCreateAccountCoupon?: Maybe<IAccountCoupon>;
  onCreateApi?: Maybe<IApi>;
  onCreateBenefit?: Maybe<IBenefit>;
  onCreateBillingAccount?: Maybe<IBillingAccount>;
  onCreateBundleSubscription?: Maybe<IBundleSubscription>;
  onCreateCheckoutSession?: Maybe<ICheckoutSession>;
  onCreateConfig?: Maybe<IConfig>;
  onCreateCouponRedemption?: Maybe<ICouponRedemption>;
  onCreateCustomerApp?: Maybe<ICustomerApp>;
  onCreateCustomerSecret?: Maybe<ICustomerSecret>;
  onCreateFlow?: Maybe<IFlow>;
  onCreateFlowRun?: Maybe<IFlowRun>;
  onCreateFlowRunLog?: Maybe<IFlowRunLog>;
  onCreateInvoice?: Maybe<IInvoice>;
  onCreateOrg?: Maybe<IOrg>;
  onCreatePermission?: Maybe<IPermission>;
  onCreatePrice?: Maybe<IPrice>;
  onCreateProduct?: Maybe<IProduct>;
  onCreateProductBundle?: Maybe<IProductBundle>;
  onCreatePublishRun?: Maybe<IPublishRun>;
  onCreateRole?: Maybe<IRole>;
  onCreateSchemaPrompt?: Maybe<ISchemaPrompt>;
  onCreateSchemaTemplate?: Maybe<ISchemaTemplate>;
  onCreateSchemaTemplateLocalization?: Maybe<ISchemaTemplateLocalization>;
  onCreateSubscriptionItem?: Maybe<ISubscriptionItem>;
  onCreateUsageRecord?: Maybe<IUsageRecord>;
  onCreateUser?: Maybe<IUser>;
  onDeleteAccountCoupon?: Maybe<IAccountCoupon>;
  onDeleteApi?: Maybe<IApi>;
  onDeleteBenefit?: Maybe<IBenefit>;
  onDeleteBillingAccount?: Maybe<IBillingAccount>;
  onDeleteBundleSubscription?: Maybe<IBundleSubscription>;
  onDeleteCheckoutSession?: Maybe<ICheckoutSession>;
  onDeleteConfig?: Maybe<IConfig>;
  onDeleteCouponRedemption?: Maybe<ICouponRedemption>;
  onDeleteCustomerApp?: Maybe<ICustomerApp>;
  onDeleteCustomerSecret?: Maybe<ICustomerSecret>;
  onDeleteFlow?: Maybe<IFlow>;
  onDeleteFlowRun?: Maybe<IFlowRun>;
  onDeleteFlowRunLog?: Maybe<IFlowRunLog>;
  onDeleteInvoice?: Maybe<IInvoice>;
  onDeleteOrg?: Maybe<IOrg>;
  onDeletePermission?: Maybe<IPermission>;
  onDeletePrice?: Maybe<IPrice>;
  onDeleteProduct?: Maybe<IProduct>;
  onDeleteProductBundle?: Maybe<IProductBundle>;
  onDeletePublishRun?: Maybe<IPublishRun>;
  onDeleteRole?: Maybe<IRole>;
  onDeleteSchemaPrompt?: Maybe<ISchemaPrompt>;
  onDeleteSchemaTemplate?: Maybe<ISchemaTemplate>;
  onDeleteSchemaTemplateLocalization?: Maybe<ISchemaTemplateLocalization>;
  onDeleteSubscriptionItem?: Maybe<ISubscriptionItem>;
  onDeleteUsageRecord?: Maybe<IUsageRecord>;
  onDeleteUser?: Maybe<IUser>;
  onUpdateAccountCoupon?: Maybe<IAccountCoupon>;
  onUpdateApi?: Maybe<IApi>;
  onUpdateBenefit?: Maybe<IBenefit>;
  onUpdateBillingAccount?: Maybe<IBillingAccount>;
  onUpdateBundleSubscription?: Maybe<IBundleSubscription>;
  onUpdateCheckoutSession?: Maybe<ICheckoutSession>;
  onUpdateConfig?: Maybe<IConfig>;
  onUpdateCouponRedemption?: Maybe<ICouponRedemption>;
  onUpdateCustomerApp?: Maybe<ICustomerApp>;
  onUpdateCustomerSecret?: Maybe<ICustomerSecret>;
  onUpdateFlow?: Maybe<IFlow>;
  onUpdateFlowRun?: Maybe<IFlowRun>;
  onUpdateFlowRunLog?: Maybe<IFlowRunLog>;
  onUpdateInvoice?: Maybe<IInvoice>;
  onUpdateOrg?: Maybe<IOrg>;
  onUpdatePermission?: Maybe<IPermission>;
  onUpdatePrice?: Maybe<IPrice>;
  onUpdateProduct?: Maybe<IProduct>;
  onUpdateProductBundle?: Maybe<IProductBundle>;
  onUpdatePublishRun?: Maybe<IPublishRun>;
  onUpdateRole?: Maybe<IRole>;
  onUpdateSchemaPrompt?: Maybe<ISchemaPrompt>;
  onUpdateSchemaTemplate?: Maybe<ISchemaTemplate>;
  onUpdateSchemaTemplateLocalization?: Maybe<ISchemaTemplateLocalization>;
  onUpdateSubscriptionItem?: Maybe<ISubscriptionItem>;
  onUpdateUsageRecord?: Maybe<IUsageRecord>;
  onUpdateUser?: Maybe<IUser>;
}


export interface ISubscriptionOnCreateAccountCouponArgs {
  configId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreateApiArgs {
  orgId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreateBenefitArgs {
  productId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreateBillingAccountArgs {
  orgId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreateBundleSubscriptionArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreateCheckoutSessionArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreateCouponRedemptionArgs {
  accountCouponId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreateCustomerAppArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreateCustomerSecretArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreateFlowArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreateFlowRunArgs {
  flowId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreateFlowRunLogArgs {
  flowRunId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreateInvoiceArgs {
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreatePermissionArgs {
  roleId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreatePriceArgs {
  productId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreateProductArgs {
  productBundleId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreatePublishRunArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreateRoleArgs {
  orgId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreateSchemaPromptArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreateSchemaTemplateLocalizationArgs {
  schemaTemplateId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreateSubscriptionItemArgs {
  bundleSubscriptionId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnCreateUsageRecordArgs {
  subscriptionItemId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteAccountCouponArgs {
  configId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteApiArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteBenefitArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteBillingAccountArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteBundleSubscriptionArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteCheckoutSessionArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteConfigArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteCouponRedemptionArgs {
  accountCouponId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteCustomerAppArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteCustomerSecretArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteFlowArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteFlowRunArgs {
  flowId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteFlowRunLogArgs {
  flowRunId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteInvoiceArgs {
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteOrgArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeletePermissionArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeletePriceArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteProductArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  productBundleId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteProductBundleArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeletePublishRunArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteRoleArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteSchemaPromptArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteSchemaTemplateArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteSchemaTemplateLocalizationArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  schemaTemplateId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteSubscriptionItemArgs {
  bundleSubscriptionId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteUsageRecordArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  subscriptionItemId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnDeleteUserArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateAccountCouponArgs {
  configId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateApiArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateBenefitArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateBillingAccountArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateBundleSubscriptionArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateCheckoutSessionArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateConfigArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateCouponRedemptionArgs {
  accountCouponId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateCustomerAppArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateCustomerSecretArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateFlowArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateFlowRunArgs {
  flowId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateFlowRunLogArgs {
  flowRunId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateInvoiceArgs {
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateOrgArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdatePermissionArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdatePriceArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateProductArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  productBundleId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateProductBundleArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdatePublishRunArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateRoleArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateSchemaPromptArgs {
  apiId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateSchemaTemplateArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateSchemaTemplateLocalizationArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  schemaTemplateId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateSubscriptionItemArgs {
  bundleSubscriptionId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateUsageRecordArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  subscriptionItemId?: InputMaybe<Scalars['ID']['input']>;
}


export interface ISubscriptionOnUpdateUserArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
}

export interface ISubscriptionItem extends INode {
  __typename?: 'SubscriptionItem';
  bundleSubscriptionId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['AWSJSON']['output']>;
  paymentProviderId?: Maybe<Scalars['ID']['output']>;
  paymentProviderPriceId?: Maybe<Scalars['ID']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  usageRecordConnection?: Maybe<ISubscriptionItemUsageRecordsConnection>;
}


export interface ISubscriptionItemUsageRecordConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IUsageRecordComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}

export interface ISubscriptionItemComparisonInput {
  and?: InputMaybe<Array<InputMaybe<ISubscriptionItemComparisonInput>>>;
  bundleSubscriptionId?: InputMaybe<IIdComparisonInput>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  not?: InputMaybe<ISubscriptionItemComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<ISubscriptionItemComparisonInput>>>;
  paymentProviderId?: InputMaybe<IIdComparisonInput>;
  paymentProviderPriceId?: InputMaybe<IIdComparisonInput>;
  quantity?: InputMaybe<IIntComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface ISubscriptionItemDeleteInput {
  id: Scalars['ID']['input'];
  paymentProviderId: Scalars['ID']['input'];
}

export interface ISubscriptionItemInput {
  bundleSubscriptionId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  paymentProviderId: Scalars['ID']['input'];
  paymentProviderPriceId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
}

export interface ISubscriptionItemUpdateInput {
  bundleSubscriptionId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  paymentProviderId: Scalars['ID']['input'];
  paymentProviderPriceId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
}

export interface ISubscriptionItemUsageRecordsConnection {
  __typename?: 'SubscriptionItemUsageRecordsConnection';
  items?: Maybe<Array<Maybe<IUsageRecord>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface ISubscriptionItemsConnection {
  __typename?: 'SubscriptionItemsConnection';
  items?: Maybe<Array<Maybe<ISubscriptionItem>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export enum TrustedEntityType {
  APIS = 'APIS',
  BILLING = 'BILLING',
  ORG = 'ORG',
  SETTINGS = 'SETTINGS',
  USERS = 'USERS'
}

export interface ITrustedEntityTypeComparisonInput {
  eq?: InputMaybe<TrustedEntityType>;
  ne?: InputMaybe<TrustedEntityType>;
}

export enum UnitType {
  EXPORT = 'EXPORT',
  GB = 'GB',
  HIH = 'HIH',
  HIT = 'HIT',
  MAU = 'MAU',
  MB = 'MB',
  OPS = 'OPS',
  QTY = 'QTY',
  REQS = 'REQS'
}

export interface IUnitTypeComparisonInput {
  eq?: InputMaybe<UnitType>;
  ne?: InputMaybe<UnitType>;
}

export interface IUsageRecord extends INode {
  __typename?: 'UsageRecord';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  paymentProviderId?: Maybe<Scalars['ID']['output']>;
  paymentProviderSubscriptionItemId?: Maybe<Scalars['ID']['output']>;
  subscriptionItemId?: Maybe<Scalars['ID']['output']>;
  timestamp?: Maybe<Scalars['AWSTimestamp']['output']>;
  totalUsageInPeriod?: Maybe<Scalars['Int']['output']>;
  unitAmount?: Maybe<Scalars['Int']['output']>;
  unitType: UnitType;
  updatedAt?: Maybe<Scalars['String']['output']>;
}

export interface IUsageRecordComparisonInput {
  and?: InputMaybe<Array<InputMaybe<IUsageRecordComparisonInput>>>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  not?: InputMaybe<IUsageRecordComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<IUsageRecordComparisonInput>>>;
  paymentProviderId?: InputMaybe<IIdComparisonInput>;
  paymentProviderSubscriptionItemId?: InputMaybe<IIdComparisonInput>;
  subscriptionItemId?: InputMaybe<IIdComparisonInput>;
  timestamp?: InputMaybe<IIntComparisonInput>;
  totalUsageInPeriod?: InputMaybe<IIntComparisonInput>;
  unitAmount?: InputMaybe<IIntComparisonInput>;
  unitType?: InputMaybe<IUnitTypeComparisonInput>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface IUsageRecordDeleteInput {
  id: Scalars['ID']['input'];
}

export interface IUsageRecordInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderId: Scalars['ID']['input'];
  paymentProviderSubscriptionItemId: Scalars['ID']['input'];
  subscriptionItemId: Scalars['ID']['input'];
  timestamp?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  totalUsageInPeriod: Scalars['Int']['input'];
  unitAmount: Scalars['Int']['input'];
  unitType: UnitType;
}

export interface IUsageRecordUpdateInput {
  id: Scalars['ID']['input'];
  paymentProviderId?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderSubscriptionItemId?: InputMaybe<Scalars['ID']['input']>;
  subscriptionItemId?: InputMaybe<Scalars['ID']['input']>;
  timestamp?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  totalUsageInPeriod?: InputMaybe<Scalars['Int']['input']>;
  unitAmount?: InputMaybe<Scalars['Int']['input']>;
  unitType?: InputMaybe<UnitType>;
}

export interface IUsageRecordsConnection {
  __typename?: 'UsageRecordsConnection';
  items?: Maybe<Array<Maybe<IUsageRecord>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export enum UsageType {
  LICENSED = 'LICENSED',
  METERED = 'METERED'
}

export interface IUsageTypeComparisonInput {
  eq?: InputMaybe<UsageType>;
  ne?: InputMaybe<UsageType>;
}

export interface IUser extends INode {
  __typename?: 'User';
  createdAt: Scalars['String']['output'];
  email?: Maybe<Scalars['AWSEmail']['output']>;
  id: Scalars['ID']['output'];
  roleConnection?: Maybe<IUserRolesConnection>;
  schemaPromptConnection?: Maybe<IUserSchemaPromptsConnection>;
  updatedAt?: Maybe<Scalars['String']['output']>;
}


export interface IUserRoleConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<IRoleComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}


export interface IUserSchemaPromptConnectionArgs {
  dynamicArgs?: InputMaybe<Scalars['AWSJSON']['input']>;
  filter?: InputMaybe<ISchemaPromptComparisonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderType>;
  sortRange?: InputMaybe<IRangeComparisonInput>;
}

export interface IUserComparisonInput {
  and?: InputMaybe<Array<InputMaybe<IUserComparisonInput>>>;
  createdAt?: InputMaybe<IStringComparisonInput>;
  email?: InputMaybe<IStringComparisonInput>;
  not?: InputMaybe<IUserComparisonInput>;
  or?: InputMaybe<Array<InputMaybe<IUserComparisonInput>>>;
  updatedAt?: InputMaybe<IStringComparisonInput>;
}

export interface IUserDeleteInput {
  id: Scalars['ID']['input'];
}

export interface IUserInput {
  email: Scalars['AWSEmail']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
}

export interface IUserRolesConnection {
  __typename?: 'UserRolesConnection';
  items?: Maybe<Array<Maybe<IRole>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IUserSchemaPromptsConnection {
  __typename?: 'UserSchemaPromptsConnection';
  items?: Maybe<Array<Maybe<ISchemaPrompt>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface IUserUpdateInput {
  email?: InputMaybe<Scalars['AWSEmail']['input']>;
  id: Scalars['ID']['input'];
}

export interface IUsersConnection {
  __typename?: 'UsersConnection';
  items?: Maybe<Array<Maybe<IUser>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

/**
 * A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.
 *
 * In some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.
 */
export interface IDirective {
  __typename?: '__Directive';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isRepeatable: Scalars['Boolean']['output'];
  locations: Array<DirectiveLocation>;
  args: Array<IInputValue>;
}


/**
 * A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.
 *
 * In some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.
 */
export interface IDirectiveArgsArgs {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
}

/** A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies. */
export enum DirectiveLocation {
  /** Location adjacent to a query operation. */
  QUERY = 'QUERY',
  /** Location adjacent to a mutation operation. */
  MUTATION = 'MUTATION',
  /** Location adjacent to a subscription operation. */
  SUBSCRIPTION = 'SUBSCRIPTION',
  /** Location adjacent to a field. */
  FIELD = 'FIELD',
  /** Location adjacent to a fragment definition. */
  FRAGMENT_DEFINITION = 'FRAGMENT_DEFINITION',
  /** Location adjacent to a fragment spread. */
  FRAGMENT_SPREAD = 'FRAGMENT_SPREAD',
  /** Location adjacent to an inline fragment. */
  INLINE_FRAGMENT = 'INLINE_FRAGMENT',
  /** Location adjacent to a variable definition. */
  VARIABLE_DEFINITION = 'VARIABLE_DEFINITION',
  /** Location adjacent to a schema definition. */
  SCHEMA = 'SCHEMA',
  /** Location adjacent to a scalar definition. */
  SCALAR = 'SCALAR',
  /** Location adjacent to an object type definition. */
  OBJECT = 'OBJECT',
  /** Location adjacent to a field definition. */
  FIELD_DEFINITION = 'FIELD_DEFINITION',
  /** Location adjacent to an argument definition. */
  ARGUMENT_DEFINITION = 'ARGUMENT_DEFINITION',
  /** Location adjacent to an interface definition. */
  INTERFACE = 'INTERFACE',
  /** Location adjacent to a union definition. */
  UNION = 'UNION',
  /** Location adjacent to an enum definition. */
  ENUM = 'ENUM',
  /** Location adjacent to an enum value definition. */
  ENUM_VALUE = 'ENUM_VALUE',
  /** Location adjacent to an input object type definition. */
  INPUT_OBJECT = 'INPUT_OBJECT',
  /** Location adjacent to an input object field definition. */
  INPUT_FIELD_DEFINITION = 'INPUT_FIELD_DEFINITION'
}

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export interface IEnumValue {
  __typename?: '__EnumValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
}

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export interface IField {
  __typename?: '__Field';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  args: Array<IInputValue>;
  type: IType;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
}


/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export interface IFieldArgsArgs {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export interface IInputValue {
  __typename?: '__InputValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  type: IType;
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
}

/** A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations. */
export interface ISchema {
  __typename?: '__Schema';
  description?: Maybe<Scalars['String']['output']>;
  /** A list of all types supported by this server. */
  types: Array<IType>;
  /** The type that query operations will be rooted at. */
  queryType: IType;
  /** If this server supports mutation, the type that mutation operations will be rooted at. */
  mutationType?: Maybe<IType>;
  /** If this server support subscription, the type that subscription operations will be rooted at. */
  subscriptionType?: Maybe<IType>;
  /** A list of all directives supported by this server. */
  directives: Array<IDirective>;
}

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export interface IType {
  __typename?: '__Type';
  kind: TypeKind;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  specifiedByUrl?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<IField>>;
  interfaces?: Maybe<Array<IType>>;
  possibleTypes?: Maybe<Array<IType>>;
  enumValues?: Maybe<Array<IEnumValue>>;
  inputFields?: Maybe<Array<IInputValue>>;
  ofType?: Maybe<IType>;
}


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export interface ITypeFieldsArgs {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
}


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export interface ITypeEnumValuesArgs {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
}


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export interface ITypeInputFieldsArgs {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
}

/** An enum describing what kind of type a given `__Type` is. */
export enum TypeKind {
  /** Indicates this type is a scalar. */
  SCALAR = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  OBJECT = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  INTERFACE = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  UNION = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  ENUM = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  INPUT_OBJECT = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  LIST = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NON_NULL = 'NON_NULL'
}

export type ICreateApiMutationVariables = Exact<{
  input: IApiInput;
}>;


export type ICreateApiMutation = { __typename?: 'Mutation', createApi?: { __typename?: 'Api', id: string, name?: string | null, state?: PublishingState | null, creationType?: ApiCreationType | null, region?: string | null, defaultAuthMode?: AuthMethodType | null, additionalAuthModes?: Array<AuthMethodType | null> | null, createdAt: string, updatedAt?: string | null, graphqlUrl?: any | null, awsAccountId?: string | null, usePrefix?: boolean | null } | null };

export type IDeleteApiMutationVariables = Exact<{
  input: IApiDeleteInput;
}>;


export type IDeleteApiMutation = { __typename?: 'Mutation', deleteApi?: { __typename?: 'Api', id: string, name?: string | null, state?: PublishingState | null } | null };

export type IDeployApiMutationVariables = Exact<{
  inlineS3ObjectInput: IInlineS3ObjectInput;
  apiId: Scalars['ID']['input'];
  apiDeclaration: Scalars['AWSJSON']['input'];
}>;


export type IDeployApiMutation = { __typename?: 'Mutation', updateApi?: { __typename?: 'Api', id: string, name?: string | null, state?: PublishingState | null, region?: string | null, createdAt: string, updatedAt?: string | null, graphqlUrl?: any | null } | null, uploadInlineS3Object?: { __typename?: 'S3Object', bucket: string, key: string, mimeType: string, url?: any | null, etag?: string | null } | null };

export type IQueryApiQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IQueryApiQuery = { __typename?: 'Query', api?: { __typename?: 'Api', id: string, name?: string | null, state?: PublishingState | null, region?: string | null, creationType?: ApiCreationType | null, schema?: any | null, queryExplorerString?: string | null, apiKey?: string | null, externalId?: string | null, graphqlUrl?: any | null, apiGatewayUrl?: any | null, apiGatewayWsUrl?: any | null, createdAt: string, updatedAt?: string | null, authProviderType?: AuthProviderType | null, authProviderClientId?: string | null, authProviderPoolId?: string | null, authProviderUrl?: any | null, defaultAuthMode?: AuthMethodType | null, additionalAuthModes?: Array<AuthMethodType | null> | null, awsAccountId?: string | null, oidc?: any | null, orgId?: string | null, usePrefix?: boolean | null, publishRunConnection?: { __typename?: 'ApiPublishRunsConnection', items?: Array<{ __typename?: 'PublishRun', id: string, createdAt: string, initState?: PublishingState | null, schema?: any | null, schemaVersion?: number | null, status?: PublishRunStatus | null } | null> | null } | null, bundleSubscriptionConnection?: { __typename?: 'ApiBundleSubscriptionsConnection', items?: Array<{ __typename?: 'BundleSubscription', products?: Array<string | null> | null } | null> | null } | null } | null };

export type IUpdateApiMutationVariables = Exact<{
  apiUpdateInput: IApiUpdateInput;
}>;


export type IUpdateApiMutation = { __typename?: 'Mutation', updateApi?: { __typename?: 'Api', id: string, name?: string | null, state?: PublishingState | null, region?: string | null, schema?: any | null, apiKey?: string | null, externalId?: string | null, graphqlUrl?: any | null, createdAt: string, updatedAt?: string | null, authProviderType?: AuthProviderType | null, authProviderClientId?: string | null, authProviderPoolId?: string | null, authProviderUrl?: any | null, defaultAuthMode?: AuthMethodType | null, additionalAuthModes?: Array<AuthMethodType | null> | null, awsAccountId?: string | null, oidc?: any | null, usePrefix?: boolean | null } | null };

export type ICreateBillingAccountMutationVariables = Exact<{
  input: IBillingAccountInput;
}>;


export type ICreateBillingAccountMutation = { __typename?: 'Mutation', createBillingAccount?: { __typename?: 'BillingAccount', id: string, name?: string | null, orgId?: string | null, billingAddress?: any | null, billingEmail?: any | null, paymentProviderId?: string | null, vatId?: string | null } | null };

export type IDeleteBillingAccountMutationVariables = Exact<{
  input: IBillingAccountDeleteInput;
}>;


export type IDeleteBillingAccountMutation = { __typename?: 'Mutation', deleteBillingAccount?: { __typename?: 'BillingAccount', id: string, paymentProviderId?: string | null } | null };

export type IListBillingAccountsByOrgQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type IListBillingAccountsByOrgQuery = { __typename?: 'Query', listBillingAccountsByOrg?: { __typename?: 'BillingAccountsConnection', items?: Array<{ __typename?: 'BillingAccount', id: string, name?: string | null, orgId?: string | null, billingAddress?: any | null, billingEmail?: any | null, paymentProviderId?: string | null, vatId?: string | null } | null> | null } | null };

export type IUpdateBillingAccountMutationVariables = Exact<{
  input: IBillingAccountUpdateInput;
}>;


export type IUpdateBillingAccountMutation = { __typename?: 'Mutation', updateBillingAccount?: { __typename?: 'BillingAccount', id: string, name?: string | null, orgId?: string | null, billingAddress?: any | null, billingEmail?: any | null, paymentProviderId?: string | null, vatId?: string | null } | null };

export type ICreateBundleSubscriptionMutationVariables = Exact<{
  input: IBundleSubscriptionInput;
}>;


export type ICreateBundleSubscriptionMutation = { __typename?: 'Mutation', createBundleSubscription?: { __typename?: 'BundleSubscription', id: string, createdAt: string, paymentProviderId?: string | null, paymentProviderSubscriptionItemIds?: Array<string | null> | null } | null };

export type IDeleteBundleSubscriptionMutationVariables = Exact<{
  input: IBundleSubscriptionDeleteInput;
}>;


export type IDeleteBundleSubscriptionMutation = { __typename?: 'Mutation', deleteBundleSubscription?: { __typename?: 'BundleSubscription', id: string } | null };

export type IListBundleSubscriptionsByApiQueryVariables = Exact<{
  apiId: Scalars['ID']['input'];
}>;


export type IListBundleSubscriptionsByApiQuery = { __typename?: 'Query', listBundleSubscriptionsByApi?: { __typename?: 'BundleSubscriptionsConnection', items?: Array<{ __typename?: 'BundleSubscription', id: string, createdAt: string, lineItems?: any | null, products?: Array<string | null> | null, paymentProviderId?: string | null, paymentProviderCheckoutSessionId?: string | null } | null> | null } | null };

export type ICreateCheckoutSessionMutationVariables = Exact<{
  input: ICheckoutSessionInput;
}>;


export type ICreateCheckoutSessionMutation = { __typename?: 'Mutation', createCheckoutSession?: { __typename?: 'CheckoutSession', id: string, createdAt: string, successUrl?: any | null, cancelUrl?: any | null, sessionUrl?: any | null, sessionId?: string | null } | null };

export type IListCheckoutSessionsByApiQueryVariables = Exact<{
  apiId: Scalars['ID']['input'];
}>;


export type IListCheckoutSessionsByApiQuery = { __typename?: 'Query', listCheckoutSessionsByApi?: { __typename?: 'CheckoutSessionsConnection', items?: Array<{ __typename?: 'CheckoutSession', apiId?: string | null, expiresAt?: any | null, metadata?: any | null, sessionId?: string | null, sessionUrl?: any | null, successUrl?: any | null, cancelUrl?: any | null, lineItems?: any | null, bundleType?: string | null, products?: Array<string | null> | null, description?: string | null } | null> | null } | null };

export type IListCheckoutSessionsByApiBySessionIdQueryVariables = Exact<{
  apiId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
}>;


export type IListCheckoutSessionsByApiBySessionIdQuery = { __typename?: 'Query', listCheckoutSessionsByApi?: { __typename?: 'CheckoutSessionsConnection', items?: Array<{ __typename?: 'CheckoutSession', createdAt: string, sessionId?: string | null, metadata?: any | null, lineItems?: any | null, products?: Array<string | null> | null } | null> | null } | null };

export type IOrgQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IOrgQuery = { __typename?: 'Query', org?: { __typename?: 'Org', id: string, createdAt: string, updatedAt?: string | null, awsAccountId?: string | null, dataProcessingCategories?: any | null, name?: string | null, apiConnection?: { __typename?: 'OrgApisConnection', nextToken?: string | null, items?: Array<{ __typename?: 'Api', id: string } | null> | null } | null, billingAccountConnection?: { __typename?: 'OrgBillingAccountsConnection', nextToken?: string | null, items?: Array<{ __typename?: 'BillingAccount', id: string } | null> | null } | null, bundleSubscriptionConnection?: { __typename?: 'OrgBundleSubscriptionsConnection', nextToken?: string | null, items?: Array<{ __typename?: 'BundleSubscription', id: string } | null> | null } | null, checkoutSessionConnection?: { __typename?: 'OrgCheckoutSessionsConnection', nextToken?: string | null, items?: Array<{ __typename?: 'CheckoutSession', id: string } | null> | null } | null, roleConnection?: { __typename?: 'OrgRolesConnection', nextToken?: string | null, items?: Array<{ __typename?: 'Role', id: string } | null> | null } | null } | null };

export type IUpdateCheckoutSessionMutationVariables = Exact<{
  input: ICheckoutSessionUpdateInput;
}>;


export type IUpdateCheckoutSessionMutation = { __typename?: 'Mutation', updateCheckoutSession?: { __typename?: 'CheckoutSession', id: string, createdAt: string, successUrl?: any | null, cancelUrl?: any | null, sessionUrl?: any | null, sessionId?: string | null } | null };

export type ICreateCouponRedemptionMutationVariables = Exact<{
  createInput: ICouponRedemptionInput;
}>;


export type ICreateCouponRedemptionMutation = { __typename?: 'Mutation', createCouponRedemption?: { __typename?: 'CouponRedemption', id: string, createdAt: string, redeemedById?: string | null, redeemedByType?: string | null, couponCode?: string | null } | null };

export type IListAccountCouponsByRegionQueryVariables = Exact<{
  configRegion: AwsRegion;
}>;


export type IListAccountCouponsByRegionQuery = { __typename?: 'Query', listAccountCouponsByConfig?: { __typename?: 'AccountCouponsConnection', items?: Array<{ __typename?: 'AccountCoupon', id: string, awsAccountId?: string | null, status?: RedemptionStatus | null } | null> | null } | null };

export type ICreateCustomerAppMutationVariables = Exact<{
  input: ICustomerAppInput;
}>;


export type ICreateCustomerAppMutation = { __typename?: 'Mutation', createCustomerApp?: { __typename?: 'CustomerApp', id: string, name?: string | null, schema?: any | null, apiId?: string | null, createdAt: string, updatedAt?: string | null } | null };

export type IQueryCustomerAppQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IQueryCustomerAppQuery = { __typename?: 'Query', customerApp?: { __typename?: 'CustomerApp', id: string, name?: string | null, schema?: any | null, apiId?: string | null, createdAt: string, updatedAt?: string | null } | null };

export type IDeleteCustomerAppMutationVariables = Exact<{
  input: ICustomerAppDeleteInput;
}>;


export type IDeleteCustomerAppMutation = { __typename?: 'Mutation', deleteCustomerApp?: { __typename?: 'CustomerApp', id: string, apiId?: string | null } | null };

export type IListCustomerAppsByApiIdQueryVariables = Exact<{
  apiId: Scalars['ID']['input'];
}>;


export type IListCustomerAppsByApiIdQuery = { __typename?: 'Query', listCustomerAppsByApi?: { __typename?: 'CustomerAppsConnection', nextToken?: string | null, items?: Array<{ __typename?: 'CustomerApp', id: string, createdAt: string, updatedAt?: string | null, name?: string | null } | null> | null } | null };

export type IUpdateCustomerAppMutationVariables = Exact<{
  input: ICustomerAppUpdateInput;
}>;


export type IUpdateCustomerAppMutation = { __typename?: 'Mutation', updateCustomerApp?: { __typename?: 'CustomerApp', id: string, name?: string | null, schema?: any | null, apiId?: string | null, createdAt: string, updatedAt?: string | null } | null };

export type IListFlowRunLogsByFlowRunQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IListFlowRunLogsByFlowRunQuery = { __typename?: 'Query', listFlowRunLogsByFlowRun?: { __typename?: 'FlowRunLogsConnection', items?: Array<{ __typename?: 'FlowRunLog', id: string, createdAt: string, updatedAt?: string | null, content?: any | null } | null> | null } | null };

export type IListFlowRunsByFlowQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IListFlowRunsByFlowQuery = { __typename?: 'Query', listFlowRunsByFlow?: { __typename?: 'FlowRunsConnection', items?: Array<{ __typename?: 'FlowRun', id: string, createdAt: string, updatedAt?: string | null, status?: string | null } | null> | null } | null };

export type ICreateFlowMutationVariables = Exact<{
  input: IFlowInput;
}>;


export type ICreateFlowMutation = { __typename?: 'Mutation', createFlow?: { __typename?: 'Flow', id: string, name?: string | null, schema?: any | null, apiId?: string | null, createdAt: string, updatedAt?: string | null } | null };

export type IDeleteFlowMutationVariables = Exact<{
  input: IFlowDeleteInput;
}>;


export type IDeleteFlowMutation = { __typename?: 'Mutation', deleteFlow?: { __typename?: 'Flow', id: string, apiId?: string | null } | null };

export type IQueryFlowQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IQueryFlowQuery = { __typename?: 'Query', flow?: { __typename?: 'Flow', id: string, createdAt: string, updatedAt?: string | null, name?: string | null, schema?: any | null, apiId?: string | null } | null };

export type IListFlowsByApiIdQueryVariables = Exact<{
  apiId: Scalars['ID']['input'];
}>;


export type IListFlowsByApiIdQuery = { __typename?: 'Query', listFlowsByApi?: { __typename?: 'FlowsConnection', nextToken?: string | null, items?: Array<{ __typename?: 'Flow', id: string, createdAt: string, updatedAt?: string | null, name?: string | null } | null> | null } | null };

export type IUpdateFlowMutationVariables = Exact<{
  input: IFlowUpdateInput;
}>;


export type IUpdateFlowMutation = { __typename?: 'Mutation', updateFlow?: { __typename?: 'Flow', id: string, name?: string | null, schema?: any | null, apiId?: string | null, createdAt: string, updatedAt?: string | null } | null };

export type IListInvoicesByBillingAccountQueryVariables = Exact<{
  billingAccountPaymentProviderId: Scalars['ID']['input'];
}>;


export type IListInvoicesByBillingAccountQuery = { __typename?: 'Query', listInvoicesByBillingAccount?: { __typename?: 'InvoicesConnection', nextToken?: string | null, items?: Array<{ __typename?: 'Invoice', id: string, date?: any | null, status?: InvoiceStatusEnum | null, amountPaid?: number | null, currency?: CurrencyType | null, invoicePdf?: any | null } | null> | null } | null };

export type IBatchQueryOrgNamesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type IBatchQueryOrgNamesQuery = { __typename?: 'Query', batchGetOrg?: Array<{ __typename?: 'Org', id: string, name?: string | null } | null> | null };

export type ICreateOrgWithOwnerMutationVariables = Exact<{
  roleId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
  userEmail: Scalars['AWSEmail']['input'];
  orgInput: IOrgInput;
}>;


export type ICreateOrgWithOwnerMutation = { __typename?: 'Mutation', createOrg?: { __typename?: 'Org', id: string, name?: string | null, awsAccountId?: string | null, dataProcessingCategories?: any | null } | null, createRole?: { __typename?: 'Role', id: string, type: RoleType, userEmail: any, orgId?: string | null, lastSignInAt?: string | null, permissionConnection?: { __typename?: 'RolePermissionsConnection', items?: Array<{ __typename?: 'Permission', type?: PermissionType | null, roleType: RoleType, entity?: TrustedEntityType | null } | null> | null } | null } | null };

export type IDeleteOrgMutationVariables = Exact<{
  orgDeleteInput: IOrgDeleteInput;
  billingAccountDeleteInput: IBillingAccountDeleteInput;
}>;


export type IDeleteOrgMutation = { __typename?: 'Mutation', deleteOrg?: { __typename?: 'Org', id: string, name?: string | null } | null, deleteBillingAccount?: { __typename?: 'BillingAccount', id: string, name?: string | null } | null };

export type IQueryOrgQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IQueryOrgQuery = { __typename?: 'Query', org?: { __typename?: 'Org', id: string, name?: string | null, awsAccountId?: string | null, dataProcessingCategories?: any | null, apiConnection?: { __typename?: 'OrgApisConnection', items?: Array<{ __typename?: 'Api', id: string, name?: string | null, region?: string | null, state?: PublishingState | null, createdAt: string, updatedAt?: string | null, defaultAuthMode?: AuthMethodType | null, additionalAuthModes?: Array<AuthMethodType | null> | null } | null> | null } | null, billingAccountConnection?: { __typename?: 'OrgBillingAccountsConnection', items?: Array<{ __typename?: 'BillingAccount', id: string, name?: string | null, billingAddress?: any | null, billingEmail?: any | null, paymentProviderId?: string | null, vatId?: string | null } | null> | null } | null } | null };

export type IUpdateOrgMutationVariables = Exact<{
  orgUpdateInput: IOrgUpdateInput;
}>;


export type IUpdateOrgMutation = { __typename?: 'Mutation', updateOrg?: { __typename?: 'Org', id: string, name?: string | null, awsAccountId?: string | null, dataProcessingCategories?: any | null } | null };

export type IUpdateOrgWithBillingAcountMutationVariables = Exact<{
  orgUpdateInput: IOrgUpdateInput;
  billingAccountUpdateInput: IBillingAccountUpdateInput;
}>;


export type IUpdateOrgWithBillingAcountMutation = { __typename?: 'Mutation', updateOrg?: { __typename?: 'Org', id: string, name?: string | null, awsAccountId?: string | null, dataProcessingCategories?: any | null } | null, updateBillingAccount?: { __typename?: 'BillingAccount', id: string, name?: string | null, vatId?: string | null, billingAddress?: any | null, billingEmail?: any | null, paymentProviderId?: string | null } | null };

export type IListProductBundlesQueryVariables = Exact<{ [key: string]: never; }>;


export type IListProductBundlesQuery = { __typename?: 'Query', listProductBundles?: { __typename?: 'ProductBundlesConnection', items?: Array<{ __typename?: 'ProductBundle', id: string, name?: string | null, type: BundleType, freeTiers?: any | null, productConnection?: { __typename?: 'ProductBundleProductsConnection', items?: Array<{ __typename?: 'Product', id: string, name?: string | null, displayName?: string | null, description?: string | null, selectedPricingIndex?: number | null, productBundleType: BundleType, type?: ProductType | null, usageType?: UsageType | null, benefitConnection?: { __typename?: 'ProductBenefitsConnection', items?: Array<{ __typename?: 'Benefit', description?: string | null, lang?: LanguageCode | null } | null> | null } | null, priceConnection?: { __typename?: 'ProductPricesConnection', items?: Array<{ __typename?: 'Price', price?: number | null, currency?: CurrencyType | null, reservedUnits?: number | null, unitAmount?: number | null, unitType?: UnitType | null, usageType?: UsageType | null, recurring?: boolean | null, billingInterval?: BillingInterval | null, paymentProviderId?: string | null, tiers?: any | null } | null> | null } | null } | null> | null } | null } | null> | null } | null };

export type ICreatePublishRunMutationVariables = Exact<{
  publishRunInput: IPublishRunInput;
  apiUpdateInput: IApiUpdateInput;
  inlineS3ObjectInput: IInlineS3ObjectInput;
}>;


export type ICreatePublishRunMutation = { __typename?: 'Mutation', createPublishRun?: { __typename?: 'PublishRun', id: string, createdAt: string, schema?: any | null, initState?: PublishingState | null, schemaVersion?: number | null } | null, updateApi?: { __typename?: 'Api', id: string, name?: string | null, state?: PublishingState | null, region?: string | null, createdAt: string, updatedAt?: string | null, graphqlUrl?: any | null } | null, uploadInlineS3Object?: { __typename?: 'S3Object', bucket: string, key: string, mimeType: string, url?: any | null, etag?: string | null } | null };

export type IQueryPublishRunQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IQueryPublishRunQuery = { __typename?: 'Query', publishRun?: { __typename?: 'PublishRun', id: string, schema?: any | null, schemaVersion?: number | null, createdAt: string } | null };

export type IQueryPublishRunsByApiQueryVariables = Exact<{
  apiId: Scalars['ID']['input'];
}>;


export type IQueryPublishRunsByApiQuery = { __typename?: 'Query', listPublishRunsByApi?: { __typename?: 'PublishRunsConnection', nextToken?: string | null, items?: Array<{ __typename?: 'PublishRun', id: string, createdAt: string, initState?: PublishingState | null, schemaVersion?: number | null, status?: PublishRunStatus | null } | null> | null } | null };

export type ICreateRoleMutationVariables = Exact<{
  input: IRoleInput;
}>;


export type ICreateRoleMutation = { __typename?: 'Mutation', createRole?: { __typename?: 'Role', id: string, type: RoleType, userEmail: any, orgId?: string | null, lastSignInAt?: string | null, permissionConnection?: { __typename?: 'RolePermissionsConnection', items?: Array<{ __typename?: 'Permission', type?: PermissionType | null, roleType: RoleType, entity?: TrustedEntityType | null } | null> | null } | null } | null };

export type IDeleteRoleMutationVariables = Exact<{
  input: IRoleDeleteInput;
}>;


export type IDeleteRoleMutation = { __typename?: 'Mutation', deleteRole?: { __typename?: 'Role', id: string, userEmail: any, orgId?: string | null } | null };

export type IQueryRoleIdsByOrgQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type IQueryRoleIdsByOrgQuery = { __typename?: 'Query', listRolesByOrg?: { __typename?: 'RolesConnection', nextToken?: string | null, items?: Array<{ __typename?: 'Role', id: string } | null> | null } | null };

export type IQueryRolesByOrgQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type IQueryRolesByOrgQuery = { __typename?: 'Query', listRolesByOrg?: { __typename?: 'RolesConnection', nextToken?: string | null, items?: Array<{ __typename?: 'Role', id: string, userEmail: any, type: RoleType, lastSignInAt?: string | null, permissionConnection?: { __typename?: 'RolePermissionsConnection', items?: Array<{ __typename?: 'Permission', type?: PermissionType | null, entity?: TrustedEntityType | null } | null> | null } | null } | null> | null } | null };

export type IUpdateRoleMutationVariables = Exact<{
  input: IRoleUpdateInput;
}>;


export type IUpdateRoleMutation = { __typename?: 'Mutation', updateRole?: { __typename?: 'Role', id: string, type: RoleType, userEmail: any, orgId?: string | null, lastSignInAt?: string | null, permissionConnection?: { __typename?: 'RolePermissionsConnection', items?: Array<{ __typename?: 'Permission', type?: PermissionType | null, entity?: TrustedEntityType | null } | null> | null } | null } | null };

export type ICreateSchemaPromptMutationVariables = Exact<{
  input: ISchemaPromptInput;
}>;


export type ICreateSchemaPromptMutation = { __typename?: 'Mutation', createSchemaPrompt?: { __typename?: 'SchemaPrompt', id: string, schema?: any | null } | null };

export type ISchemaPromptQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ISchemaPromptQuery = { __typename?: 'Query', schemaPrompt?: { __typename?: 'SchemaPrompt', schema?: any | null } | null };

export type IOnUpdateSchemaPromptSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IOnUpdateSchemaPromptSubscription = { __typename?: 'Subscription', onUpdateSchemaPrompt?: { __typename?: 'SchemaPrompt', id: string } | null };

export type IListSchemaTemplatesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ISchemaTemplateComparisonInput>;
  lang?: InputMaybe<LanguageCode>;
}>;


export type IListSchemaTemplatesQuery = { __typename?: 'Query', listSchemaTemplates?: { __typename?: 'SchemaTemplatesConnection', nextToken?: string | null, items?: Array<{ __typename?: 'SchemaTemplate', id: string, schema?: any | null, schemaTemplateLocalizationConnection?: { __typename?: 'SchemaTemplateSchemaTemplateLocalizationsConnection', items?: Array<{ __typename?: 'SchemaTemplateLocalization', name?: string | null, description?: string | null } | null> | null } | null } | null> | null } | null };

export type IIntrospectionQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type IIntrospectionQueryQuery = { __typename?: 'Query', __schema: { __typename?: '__Schema', queryType: { __typename?: '__Type', name?: string | null }, mutationType?: { __typename?: '__Type', name?: string | null } | null, subscriptionType?: { __typename?: '__Type', name?: string | null } | null, types: Array<{ __typename?: '__Type', kind: TypeKind, name?: string | null, description?: string | null, fields?: Array<{ __typename?: '__Field', name: string, description?: string | null, isDeprecated: boolean, deprecationReason?: string | null, args: Array<{ __typename?: '__InputValue', name: string, description?: string | null, defaultValue?: string | null, type: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null } | null } | null } | null } | null } | null } | null } | null } }>, type: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null } | null } | null } | null } | null } | null } | null } | null } }> | null, inputFields?: Array<{ __typename?: '__InputValue', name: string, description?: string | null, defaultValue?: string | null, type: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null } | null } | null } | null } | null } | null } | null } | null } }> | null, interfaces?: Array<{ __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null } | null } | null } | null } | null } | null } | null } | null }> | null, enumValues?: Array<{ __typename?: '__EnumValue', name: string, description?: string | null, isDeprecated: boolean, deprecationReason?: string | null }> | null, possibleTypes?: Array<{ __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null } | null } | null } | null } | null } | null } | null } | null }> | null }>, directives: Array<{ __typename?: '__Directive', name: string, description?: string | null, locations: Array<DirectiveLocation>, args: Array<{ __typename?: '__InputValue', name: string, description?: string | null, defaultValue?: string | null, type: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null } | null } | null } | null } | null } | null } | null } | null } }> }> } };

export type IFullTypeFragment = { __typename?: '__Type', kind: TypeKind, name?: string | null, description?: string | null, fields?: Array<{ __typename?: '__Field', name: string, description?: string | null, isDeprecated: boolean, deprecationReason?: string | null, args: Array<{ __typename?: '__InputValue', name: string, description?: string | null, defaultValue?: string | null, type: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null } | null } | null } | null } | null } | null } | null } | null } }>, type: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null } | null } | null } | null } | null } | null } | null } | null } }> | null, inputFields?: Array<{ __typename?: '__InputValue', name: string, description?: string | null, defaultValue?: string | null, type: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null } | null } | null } | null } | null } | null } | null } | null } }> | null, interfaces?: Array<{ __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null } | null } | null } | null } | null } | null } | null } | null }> | null, enumValues?: Array<{ __typename?: '__EnumValue', name: string, description?: string | null, isDeprecated: boolean, deprecationReason?: string | null }> | null, possibleTypes?: Array<{ __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null } | null } | null } | null } | null } | null } | null } | null }> | null };

export type IInputValueFragment = { __typename?: '__InputValue', name: string, description?: string | null, defaultValue?: string | null, type: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null } | null } | null } | null } | null } | null } | null } | null } };

export type ITypeRefFragment = { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null, ofType?: { __typename?: '__Type', kind: TypeKind, name?: string | null } | null } | null } | null } | null } | null } | null } | null };

export type ICreateSubscriptionItemMutationVariables = Exact<{
  input: ISubscriptionItemInput;
}>;


export type ICreateSubscriptionItemMutation = { __typename?: 'Mutation', createSubscriptionItem?: { __typename?: 'SubscriptionItem', id: string } | null };

export type ICreateUserMutationVariables = Exact<{
  input: IUserInput;
}>;


export type ICreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'User', id: string, email?: any | null } | null };

export type IQueryUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IQueryUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, email?: any | null, roleConnection?: { __typename?: 'UserRolesConnection', items?: Array<{ __typename?: 'Role', id: string, orgId?: string | null, type: RoleType, permissionConnection?: { __typename?: 'RolePermissionsConnection', items?: Array<{ __typename?: 'Permission', actions?: Array<string | null> | null, type?: PermissionType | null, entity?: TrustedEntityType | null, roleType: RoleType } | null> | null } | null } | null> | null } | null } | null };

export type IUpdateUserMutationVariables = Exact<{
  input: IUserUpdateInput;
}>;


export type IUpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string, email?: any | null } | null };
